const EN = {
  '1': 'January',
  '2': 'February',
  '3': 'March',
  '4': 'April',
  '5': 'May',
  '6': 'June',
  '7': 'July',
  '8': 'August',
  '9': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December',
  'pull.refresh.deactivate': 'Pull to refresh',
  'pull.refresh.activate': 'Release to refresh',
  'pull.refresh.release': 'Loading more',
  'push.refresh.activate': 'Loading more',
  'push.refresh.noMore': 'No more info',
  'click.refresh': 'Click to refresh',
  'share.whatsapp.tip': 'WhatsApp might not be installed on your phone, install it and try agian.',
  'share.ok': 'OK',
  'share.install': 'Install Soundi Radio APP Now',
  'share.download': 'Download',
  'share.play': 'Play on Soundi Radio',
  'share.live': 'Live',
  'blank': '<p>No related content</p> <p>Please check other channels</p>',
  'commonErr': '<p>System busy,</p><p>please try again later</p>',
  'loading': 'Loading...',
  'retry': 'Retry',
  'viewMore': 'View more',
  'more': 'more',
  'month.select': 'Select Month',
  'hot': 'Hot',
  'all': 'All',
  'month.select.day': 'Select Date',
  'coin.merchant.title': 'CoinSeller',
  'coin.merchant.set.password': 'Set your trading password',
  'coin.merchant.confirm.again': 'Confirm the transaction password again',
  'coin.merchant.enter.password': 'Enter your transaction password',
  'coin.merchant.enter.original.password': 'Enter the original password',
  'coin.merchant.enter.new.password': 'Enter new password',
  'coin.merchant.confirm.new.again': 'Confirm the new password again',
  'coin.merchant.change.password': 'Change\npassword',
  'coin.merchant.history.title': 'Transaction\nHistory',
  'coin.merchant.history': 'History',
  'coin.merchant.user': 'User',
  'coin.merchant.data': 'Data',
  'coin.merchant.transaction.times': 'Transaction Times',
  'coin.merchant.monthly.current': 'Monthly Amount - {%s}',
  'coin.merchant.monthly.last': 'Monthly Amount - {%s}',
  'coin.merchant.chat': 'Chat',
  'coin.merchant.coins.num': 'Coins Inventory:',
  'coin.merchant.transfer.coins': 'Transfer Coins',
  'coin.merchant.enter.user.id': 'Enter user id',
  'coin.merchant.search': 'Inquiry',
  'coin.merchant.not.found': 'User not found',
  'coin.merchant.enter.amount': 'Enter the amount',
  'coin.merchant.tips': 'You are about to transfer an additional amount to the user, please confirm the name and the amount of coins again. This operation is irreversible, and the official is not responsible for any misoperation.',
  'coin.merchant.enter.transaction.password': 'Enter the transaction password',
  'common.cap.Confirm': 'Confirm',
  'coin.merchant.enter': 'Enter',
  'coin.merchant.to': 'To:',
  'coin.merchant.amount': 'Amount:',
  'coin.merchant.id': 'ID',
  'coin.merchant.search.id': 'Search ID',
  'coin.merchant.recharge.summary': 'Recharge',
  'coin.merchant.coin.sales': 'Coin Sales',
  'coin.merchant.password.tips': 'The password must be at least 8 characters , and must consist of capital and small letters and numbers.',
  'coin.merchant.password.error': 'Wrong Password.Please try again.',
  'coin.merchant.success': 'Remittance succeeded',
  'coin.merchant.list.title': 'Select amount',
  'coin.merchant.list.desc': 'Transfer coins to this user is equivalent to recharge, which will also increase vip experience.',
  'coin.merchant.transfer': 'Transfer',
  'coin.merchant.recharge.title': 'Coinseller\nRecharge',
  'coin.merchant.min.input': 'Minimum amount 1000',
  'coin.merchant.der.channel': 'Payment Method:',
  'coin.merchant.der.channel.tips': 'If you cannot complete the payment through the following methods, please contact the WhatsApp of the official team to inquire about the purchase:',
  'coin.merchant.der.channel.tips.link': 'copy',
  'coin.merchant.der.current.country': 'Currently using the payment channel of',
  'coin.merchant.der.change.country': 'Select country',
  'coin.merchant.der.modal.title': 'Method of Payment',
  'common.cap.Recharge': 'Recharge',
  'coin.merchant.der.id': 'TalkTalk ID',
  'coin.merchant.der.name': 'Your TalkTalk Nickname:',
  'coin.merchant.der.error': '*No Results Found',
  'coin.merchant.der.amount': 'Recharge Amount:',
  'coin.merchant.der.redeem': 'Redeem',
  'coin.merchant.der.fail': 'Fail to Recharge',
  'coin.merchant.der.fail.tips': 'Failed to recharge your account, please contact us at: TT_support@molelive.com if you have any questions!',
  'coin.merchant.der.complete': 'Recharge Complete',
  'coin.merchant.der.complete.tips': '{number} coins have been successfully recharged to {name}! Please log in to enjoy more fun!',
  'coin.merchant.der.another': 'Recharge Another Account',
  'coin.merchant.der.more': 'Recharge More',
  'coin.merchant.der.problem': 'Encounter Problems?',
  'coin.merchant.der.bind.phone': 'Bind mobile number',
  'coin.merchant.der.sms.code': 'Enter verification code',
  'coin.merchant.der.sms.tips': 'An abnormal activity has been detected. To ensure the security of your account, please finish the verification process below.',
  'coin.merchant.der.bind.phone.placeholder': 'Phone Number',
  'coin.merchant.der.resend': 'Resend',
  'common.cap.Continue': 'Continue',
  'coin.merchant.der.code.tips': 'If you cannot receive the verification code, please contact the WhatsApp of the official team:',
  'total.rank.gift': 'WEEKLY<br />STAR',
  'total.rank.hour': 'Hourly',
  'total.rank.day': 'Daily',
  'total.rank.week': 'Weekly',
  'total.rank.month': 'Monthly',
  'total.rank.last.hour': 'Last Hour TOP3',
  'total.rank.last.day': 'Last Day TOP3',
  'total.rank.last.week': 'Last Week TOP3',
  'total.rank.last.month': 'Last Month TOP3',
  'total.rank.this.hour': 'This Hour',
  'total.rank.this.day': 'This Day',
  'total.rank.this.week': 'This Week',
  'total.rank.this.month': 'This Month',
  'total.rank.gap': 'Gap{X}',
  'total.rank.hide': 'Hide in Rank',
  'total.rank.hide.name': 'Mr.Mystery',
  'total.rank.hide.info': 'Hidden Information',
  'total.rank.help.title': 'Ranking Rules',
  'total.rank.help': '<h1>Ranking Type</h1>\n<p>Rank &lt;Room&gt;: During the time period, all rooms will be ranked according to the amount of coins gifts sent in the room.</p>\n<p>Rank &lt;GIFTER&gt;: During the time period, all users will be ranked according to the amount of coins gifts sent by the user.</p>\n<p>Rank &lt;CHARMER&gt;: During the time period, all users will be ranked according to the amount of coins gifts you received.</p>\n<h1>Rank Time Cycle</h1>\n<p>The ranking cycle is usually hours, days, weeks, and months.</p>\n<p>The Rank shows the top 3 of the previous cycle, as well as the top 50 of the current cycle, updated in real time.\n(With a delay of less than 1 minute)</p>\n<p>Refresh Time (UTC+3): Daily Rank refresh at 5am; Weekly Rank refresh at 5am every Monday; Monthly Rank refresh at 5am on the 1st of every month.</p>\n<h1>Privacy Protect</h1>\n<p>Some Ranks won\'t show specific numbers; </p>\n<p>However, the difference between the previous ranking is displayed; </p>\n<p>The top 3 won\'t show the difference between each other.</p>',
  'total.rank.cp.help.title': 'CP Ranking Rules',
  'total.rank.cp.help': '<h1>CP Ranking Rules</h1>\n<p>The CP Leaderboard showcases the most popular and longest-lasting amazing CPs in real time. Get on the list to earn full platform exposure and let everyone see your sweetness!</p>\n<h1>Intimacy Leaderboard</h1>\n<p>Ranking Rule: Sorted by new intimacy gained during the period, highest to lowest. Only top 50 are displayed.</p>\n<p>Eligibility: Only CPs with intimacy growth in the last 7 days can be listed.</p>\n<h1>Longest CP Leaderboard</h1>\n<p>Eligibility: Valid CP pairs with intimacy growth in the last 7 days.</p>\n<p>Ranking Rules:<br/>1. First sorted by relationship duration, longest to shortest<br/>2. If duration is the same, sorted by total current intimacy, highest to lowest</p>\n<h1>Automatic Removal from All Leaderboards</h1>\n<p>You will be automatically removed if:<br/>● CP relationship is ended<br/>● No intimacy growth for 7 consecutive days</p>\n<p>Violation Policy<br/>CP pairs who cheat to gain intimacy through unfair means will have their leaderboard status revoked immediately, and the corresponding fraudulent intimacy points will be deducted.</p>',
  'total.rank.help.eu.ios.hide': '<h1>Rank Time Cycle</h1>\n<p>The Rank shows the top 3 of the previous cycle, as well as the top 50 of the current cycle, updated in real time.\n(With a delay of less than 1 minute)</p>\n<p>Refresh Time (UTC+3): Daily Rank refresh at 5am; Weekly Rank refresh at 5am every Monday; Monthly Rank refresh at 5am on the 1st of every month.</p>\n<h1>Privacy Protect</h1>\n<p>Some Ranks won\'t show specific numbers; </p>\n<p>However, the difference between the previous ranking is displayed; </p>\n<p>The top 3 won\'t show the difference between each other.</p>',
  'total.rank.help.eu': '<h1>Ranking Type</h1>\n<p>Rank &lt;GIFTER&gt;: During the time period, all users will be ranked according to the amount of coins gifts sent by the user.</p>\n<p>Rank &lt;CHARMER&gt;: During the time period, all users will be ranked according to the amount of coins gifts you received.</p>\n<h1>Rank Time Cycle</h1>\n<p>The Rank shows the top 3 of the previous cycle, as well as the top 50 of the current cycle, updated in real time.\n(With a delay of less than 1 minute)</p>\n<p>Refresh Time (UTC+3): Daily Rank refresh at 5am; Weekly Rank refresh at 5am every Monday; Monthly Rank refresh at 5am on the 1st of every month.</p>\n<h1>Privacy Protect</h1>\n<p>Some Ranks won\'t show specific numbers; </p>\n<p>However, the difference between the previous ranking is displayed; </p>\n<p>The top 3 won\'t show the difference between each other.</p>',
  'common.cap.Ranking': 'Ranking',
  'total.rank.room': 'ROOM',
  'total.rank.sent': 'GIFTER',
  'common.up.RECEIVED': 'CHARMER',
  'fission.relation.by.amount': 'By Amount',
  'fission.relation.by.time': 'By Time',
  'total.rank.daily': 'Daily',
  'common.cap.Countdown': 'Countdown',
  'common.up.RULES': 'RULES',
  'common.up.DAYS': 'DAYS',
  'common.up.HOURS': 'HOURS',
  'common.up.MINS': 'MINS',
  'common.cap.Successfully.Collected': 'Successfully Collected',
  'common.cap.Countdown.to.Start': 'Countdown To Start',
  'common.cap.Day': 'Day',
  'common.cap.Hour': 'Hour',
  'common.cap.Min': 'Min',
  'common.cap.Sec': 'Sec',
  'common.cap.Rules': 'Rules',
  'common.cap.event.over': 'The event is over',
  'recharge.event.tab.1': 'Recharge Progress',
  'recharge.event.amount.reached': 'Amount of coins reached',
  'recharge.event.ranking.list': 'Ranking List',
  'recharge.event.group': 'Group',
  'recharge.event.next.1': 'Only need',
  'recharge.event.next.2': 'coins to reach the next level',
  'recharge.event.rewards.for': 'Rewards For',
  'recharge.event.trouble': 'Are you having trouble with recharging?',
  'recharge.event.done': 'Congratulations!You have reached the highest level! Enjoy your rewards now!',
  'fission.trouble': 'Are you having trouble with recharging?',
  'common.cap.No': 'No',
  'common.cap.Unfortunately.Yes': 'Unfortunately Yes',
  'common.cap.Waiting': 'Waiting',
  'common.cap.update': 'Please update version to use new features',
  'common.cap.Customer.Server': 'Customer Service',
  'common.cap.Ranking.click': 'Click',
  'common.cap.Ranking.click.text': 'to check different prizes',
  'common.cap.Collect': 'Collect',
  'common.cap.Collected': 'Collected',
  'common.cap.Limited.Gifts': 'Limited Gifts',
  'family.football.target': 'Coins Rewards Target',
  'dream.city.rule.reward': 'Rules&\nRewards',
  'dream.city.city.map': 'City Map',
  'dream.city.rules': 'Event Rules',
  'dream.city.supply.reward': 'Supply Station Rewards',
  'dream.city.wealth': 'Wealth',
  'dream.city.charm': 'Charm',
  'dream.city.wealth.rank': 'Wealth',
  'dream.city.charm.rank': 'Charm',
  'dream.city.current.coins': 'Current Coins',
  'dream.city.current.diamonds': 'Current Diamonds',
  'dream.city.go': 'GO',
  'dream.city.will.get': 'You will get',
  'dream.city.received': 'Congratulations! You have received',
  'dream.city.top5': 'Top 5 users who reach the supply station at the sonnest will get the supply rewards.',
  'dream.city.waiting': 'waiting',
  'common.cap.Go': 'Go',
  'lucky.darw.ruls.1': 'Send gifts inside the chatrooms and get a chance to enter the draw',
  'lucky.darw.ruls.2': 'Every 5000 coins worth of gifts give you 1 draw',
  'lucky.darw.ruls.3': 'For example : 50,000 coins = 10 draws , 100,000 coins = 20 draws . Send more gifts to get more draws',
  'lucky.darw.ruls.4': 'If the day end and you didn\'t use your draws , all your draws will become 0 after the event done',
  'lucky.darw.number': 'the number of my draws',
  'lucky.darw.reset.time': 'Countdown',
  'lucky.darw.ranking': 'Draw Ranking',
  'lucky.darw.use': 'GO TO USE',
  'lucky.darw.no.times': 'The current number of draw is not enough, go to the room and send gifts',
  'lucky.darw.end': 'Event not in progress',
  'lucky.darw.coin.one.times': 'Draw 1 time costs',
  'lucky.darw.coin.draw': 'Draw',
  'lucky.darw.coin.more.times': 'times will cost',
  'lucky.darw.coin.more.will.cost': 'will cost',
  'fission.coins': 'coins',
  'common.recharge.text': 'Coins are not enough. Do you want to recharge?',
  'fission.cancel': 'Cancel',
  'lucky.darw.title': 'Lucky Draw',
  'gacha.play.3': 'time',
  'gacha.play.1': 'Open',
  'gacha.play.2': 'times',
  'common.cap.Congratulations': 'Congratulations',
  'common.up.OK': 'OK',
  'lucky.darw.coin.one.times.two': 'Choose and click Go',
  'common.Cap.Dating': 'Dating',
  'cp.list.limit.tips': 'Send limited gifts to reach the level can unlock the dating location.',
  'cp.list.unlock.contributor': 'Location Contributor',
  'common.Cap.Top1': 'Top1',
  'cp.list.cur.reward.text': 'Unlock this location to receive the following rewards.',
  'iftar.total.ranking': 'Total Ranking',
  'iftar.congratulations.unlocking': 'Congratulations on your participation in unlocking the dish:',
  'iftar.you.received': 'You have received:',
  'activity.gift.list.send': 'Contributor',
  'iftar.daily.ranking': 'Daily Ranking',
  'iftar.reward.target': 'Coins Rewards Target',
  'common.cap.Rewards': 'Rewards',
  'common.up.SECS': 'SECS',
  'lucky.recharge.draw.start': 'Start lottery',
  'lucky.recharge.draw.num': 'my available raffle tickets',
  'lucky.recharge.draw.record': 'View my winning record',
  'lucky.recharge.tab.wheel': 'Fortune wheel',
  'lucky.recharge.tab.grid': 'Fortune price pool',
  'lucky.recharge.wheel.tip.text.1': 'Every time you recharge to a certain amount, you can get a lottery ticket, 100% winning!',
  'lucky.recharge.wheel.tip.text.2': 'The more draws, the greater the chance of winning the jackpot!',
  'lucky.recharge.ticket': 'raffle\nticket',
  'lucky.recharge.recharged': 'Recharged',
  'lucky.recharge.recharge.next': 'Recharge {N}<div></div> to get {X} lottery tickets',
  'lucky.recharge.recharge.done': 'You have won all the spinner tickets',
  'lucky.recharge.hide.info': 'hide personal information',
  'lucky.recharge.recharge.gift.bag': 'Recharge\npackage',
  'lucky.recharge.recharge.gift.bag.text': 'Recharge {N} every day to get',
  'lucky.recharge.recharge.gift.bag.text.1': 'Prize pool lottery ticket*1',
  'lucky.recharge.recharge.no': 'Insufficient raffle tickets',
  'common.Cap.Uncompleted': 'Uncompleted',
  'common.Collect': 'Collect',
  'break.through.text.14': 'Congratulations! You have been awarded',
  'world.cup.records': 'Records',
  'world.cup.time': 'Time',
  'common.number': 'Number',
  'recharge.result.pending': 'Operation complete',
  'recharge.result.tips': 'If the coins do not arrive in time, please don\'t worry, there may be network delays. If you have any questions, please contact Soyou official customer service.',
  'recharge.result.tips.click': 'Click to return to APP',
  'new.task.go': 'Go',
  'new.task.done': 'Done',
  'task.center.title': 'Task Center',
  'task.center.common.level': 'Level',
  'common.cap.Event.To.Start': 'Event is about to start',
  'task.center.limit.task': 'Limited Task',
  'task.center.normal.task': 'Normal Task',
  'task.center.limit.today': 'Today',
  'task.center.limit.Total': 'Total',
  'task.center.limit.Diamonds.Received': 'Diamonds Received',
  'task.center.limit.Reward.Received': 'Reward Received',
  'task.center.limit.receive': 'Receive',
  'task.center.limit.extra': 'Extra',
  'task.center.limit.to.start': 'Event has not started yet',
  'gift.wall.title': 'Gifts',
  'gift.wall.help.text1': 'Gifts that exceed {num} coins at a time will appear on the gift wall',
  'gift.wall.help.text2': 'The gift that has more coins will be displayed in the first rankings',
  'gift.wall.help.text3': 'The record on the gift wall will be kept for 24 hours',
  'level.user': 'User Level',
  'level.halo': 'Halo Level',
  'level.halo.question1.title': 'Benefits of High Level',
  'level.halo.question1.answer1': 'Higher the Level, Brighter the Halo',
  'level.halo.question2.title': 'Level Icon Display',
  'level.halo.question2.answer1': 'Higher the level, More unique the icon',
  'level.halo.question3.title': 'Level Up Reward',
  'level.halo.question3.answer1': 'Level Up To Get Amazing Rewards',
  'level.halo.question4.title': 'Ways to Level Up',
  'level.halo.question4.answer1': 'Receive gift worth 1 coin, Gain 1 exp.\nHigher the exp, Faster the upgrade.',
  'level.user.question1.title': 'Benefits of High Level',
  'level.user.question1.answer1': 'You will get special items and reward.',
  'level.user.question2.title': 'Ways to Level Up',
  'level.user.question2.answer1': 'Chat in the room, play games and send gifts',
  'level.user.question2.answer2': 'Complete daily tasks, gain experience to level up',
  'level.user.question2.answer7': 'Have party in room',
  'level.user.question2.answer8': 'Send gift by coins',
  'level.user.question2.answer9': 'Complete tasks and claim EXP',
  'level.user.question3.title': 'Level Icon Display',
  'level.user.question3.answer1': 'Higher the level, More unique the icon',
  'level.user.question4.title': 'Level Up Reward',
  'level.user.question4.answer1': 'Level Up To Get Amazing Rewards',
  'level.user.level': 'Level',
  'level.user.icon': 'Icon',
  'level.user.tips': 'As you continue to gain experience points, your level will gradually increase',
  'level.user.way.up': 'Ways to increase experience points:',
  'about.badges.title': 'About Badges',
  'about.badges.0': 'Wear Badge',
  'about.badges.1': 'All badges can be worn, and up to five badges can be worn at the same time.',
  'about.badges.2': 'Honor Badge',
  'about.badges.3': 'The badges unlocked by the cumulative monthly values are counted on the 1st of each month whether they are owned or not. The validity period lasts for one month.',
  'flowWater': 'Coins Details',
  'coinBack': 'Coins Returned',
  'tips': 'No more data',
  'vip.privileges.title.privacy': 'Privacy Security',
  'vip.privileges.label.privacy': 'Others cannot search you/your voice room',
  'vip.privileges.title.invisible': 'Invisble Mode',
  'vip.privileges.label.invisible': 'Stay invisble and hide yourself in others\' recommendations',
  'vip.privileges.title.blockMessages': 'Quiet Mode',
  'vip.privileges.label.blockMessages': 'Block Strangers\' Messages and stay undisturbed.',
  'vip.privileges.title': 'VIP Privileges',
  'vip.privileges.activate': 'VIP{N} Activate',
  'vip.privileges.stealth.text': 'Hide my access history',
  'vip.privileges.stealth.open': 'Open',
  'vip.privileges.stealth.close': 'Close',
  'vip.privileges.title.icon': 'VIP Label',
  'vip.privileges.label.icon': 'Remarkable VIP lable, exclusive identity of VIP users, shows your honour.',
  'vip.privileges.title.visitor': 'Visiting Traces',
  'vip.privileges.label.visitor': 'View all visitor traces so you don\'t miss any interested person and fans.',
  'vip.privileges.title.list': 'Priority Display',
  'vip.privileges.label.list': 'Priority display of search results.',
  'vip.privileges.title.follower': 'Higher Following Upper Limit.',
  'vip.privileges.label.follower': 'You can become VIP and add more friends. Non-VIP can follow 1000 people. VIP1-3 will increase 1000 by each, VIP4-6 will increase 2000 by each, VIP7 and above will increase 3000 by each.',
  'vip.privileges.title.sign': 'VIP Check-in Rewards',
  'vip.privileges.label.sign': 'VIP can claim double check-in rewards',
  'vip.privileges.title.stealth': 'Invisible Visit',
  'vip.privileges.label.stealth': 'When you visit other users, no history will be recorded',
  'vip.privileges.title.name': 'Username highlight',
  'vip.privileges.label.name': 'Users will get special effects to decorate the username',
  'vip.privileges.title.avatar': 'VIP Frame',
  'vip.privileges.label.avatar': 'Exclusive frame to show your identity.',
  'vip.privileges.title.bubble': 'VIP Chat Bubble',
  'vip.privileges.label.bubble': 'Exclusive chat bubble makes your speech stand out.',
  'vip.privileges.title.room': 'VIP Mini Card',
  'vip.privileges.label.room': 'Exclusive vip room card',
  'vip.privileges.title.picture': 'Exclusive mini card to highlight your honour.',
  'vip.privileges.label.picture': 'The option to send images on the bullet chat',
  'vip.privileges.title.message': 'Top Message List',
  'vip.privileges.label.message': 'You can put other users\' dialogs on top of the message list.',
  'vip.privileges.title.vehicle': 'VIP Vehicle',
  'vip.privileges.label.vehicle': 'Exclusive VIP vehicles',
  'vip.privileges.title.rank': 'Hide Identity',
  'vip.privileges.label.rank': 'You can turn on the [Hide Identity]button to appear as a mystery man on the rankings.',
  'vip.privileges.title.broadcast': 'App Notification',
  'vip.privileges.label.broadcast': 'When you reach VIP8 and above, the upgrade will trigger app notification.',
  'vip.privileges.title.id': 'Exclusive ID',
  'vip.privileges.label.id': 'Get your exclusive ID and let others remember you at a glance! VIP8: ABABAB(A and B should be different) VIP9: AAABB(A and B should be different) VIP10: ABAB(A and B should be different) VIP11: AABB(A and B should be different) All the form can\'t start with 0. You need to contact VIP customer service to get exclusive ID.',
  'vip.privileges.title.protection': 'Prevent Removal',
  'vip.privileges.label.protection': 'Never worry about being removed from mic or any rooms.',
  'vip.privileges.title.gif': 'Customized Dynamic Frame',
  'vip.privileges.label.gif': 'Custimized your exclusive dynamic frame. When you reach VIP9, please contact Customer Service to get Customized Dynamic Frame,each user only has one chance to customize.',
  'vip.privileges.title.gift': 'Customized Gifts',
  'vip.privileges.label.gift': 'Custimized your exclusive gift. When you reach VIP10, please contact Customer Service to get Customized Gifts,each user only has one chance to customize.',
  'vip.privileges.title.exclusivevehicles': 'Customized Vehicle',
  'vip.privileges.label.exclusivevehicles': 'Custimized your exclusive mount. When you reach VIP11, please contact Customer Service to get Customized Vehicle,each user only has one chance to customize.',
  'vip.privileges.title.open': 'Customized Open Page',
  'vip.privileges.label.open': 'Others can automatically see you once open the app, the unbeatable glory! When you reach VIP12, please contact Customer Service to get a 24h Customized Open Page,each user only has one chance to customize.',
  'vip.privileges.update.info': 'The vip system has been updated, your version is too low to view the latest features. Please update to the latest version and enjoy the new vip function!',
  'aristocracy.vip.title': 'Aristocracy',
  'vip.help.1': 'VIP Rules',
  'vip.help.2': 'What is the VIP?',
  'vip.help.3': 'VIP is the special class in Soyou. It includes 11 identify levels. You can have the corresponding privileges after you own a VIP.',
  'vip.help.4': 'How to upgrade VIP level?',
  'vip.help.5': '1.Recharge $1 can get 1 VIP EXP.</br>\n2.Your VIP level will upgrade immediately when VIP EXP reaches the upgrade requirement in that month.</br>\n3.From the 1st day of each month, each person\'s initial VIP EXP will be reset to 0. And your VIP level will be decided by accumulated EXP amount.',
  'vip.help.6': 'Upgrade Vip Level Rules',
  'vip.help.7': 'Upgrade Rules',
  'vip.help.8': 'Once you reach the upgrade conditions this month, your VIP level will be updated immediately.And the VIP level will be maintained till the end of the next month. For example, the user reached VIP5 on March 10 and his VIP5 will continute until April 30.',
  'vip.help.9': 'Retain/Downgrade Rules',
  'vip.help.10': 'If your accumulated EXP value reaches the requirements for your current VIP level in this month, you will keep your VIP level in the next month; otherwise, your VIP level will be downgraded next month.For example: if you are VIP5 in May, but you only accumulated VIP3 in May, then your VIP level will be downgraded to VIP3 from June.',
  'vip.help.11': 'VIP Level Rebate',
  'vip.help.12': 'Based on the VIP Level on the 1st of day each month, we will send a cretain amount of VIP EXP to users according to their VIP Levels on the 1st day of each month.',
  'vip.help.13': 'Level',
  'vip.help.14': 'EXP Value Interval',
  'vip.help.15': 'EXP Value Rebate',
  'vip.help.update.info': 'The vip system has been updated, your version is too low to view the latest features. Please update to the latest version and enjoy the new vip function!',
  'to.exchange.page.button': 'Exchange',
  'details': 'Diamonds Details',
  'miss': 'Missed Diamonds',
  'profit': 'Income Statistics',
  'missToday': 'Missed-Today',
  'cumulativeMiss': 'Missed-Total',
  'distributionOfDiamondIncome': 'Diamonds income distribution',
  'getDiamondsMonth': 'Diamonds this month：',
  'getDiamondsDay': 'Diamonds today：',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'daily': 'Daily',
  'month': 'Month',
  'voiceChat': 'User Ratings <br /> for Voice Chat with the anchor',
  'voiceChat1': 'User Ratings <br /> for Voice Chat with me',
  'quickCall': 'User Ratings <br /> for Quick Call with the anchor',
  'quickCall1': 'User Ratings <br /> for Quick Call with me',
  'chatting': 'Message chat performance',
  'chatting1': 'My chat performance',
  'chatSpeed': 'Reply speed',
  'chatSpeed1': 'My speed of replying messages',
  'like': 'like',
  'boring': 'boring',
  'Hate': 'Hate',
  'chatConversation': '💬 Chat Rounds',
  'reached': '🙋‍♀️ Number of users',
  'count': '🙋‍♀️ Messages',
  'speed': 'Reply speed',
  'quality': 'Chat quality',
  'call': 'Call & Rating',
  'currentCycle': 'Current Cycle',
  'speedTitle': 'Reply to Message Income Rules',
  'roundTitle': 'Chat Rounds Income Rules',
  'modalTips': 'Faster you reply to messages will improve user experience, and the more diamonds you earn.',
  'modalTipsTwo': 'The higher quality of your reply content and more chat rounds will improve user experience, and the more diamonds you earn:',
  'modalTipsThree': 'The higher quality your replies are, the more diamonds you earn. Extra rewards daily limit {%s}',
  'modalSpeed': 'Response speed',
  'modalIncome': 'Income Rate',
  'modalRound': 'Chat rounds',
  'modalReward': 'Extra rewards',
  'modalBtn': 'Continue To Chat',
  'cycleDiamonds': 'Diamonds this cycle',
  'my.earning.title': 'My Earnings',
  'my.earning.tips': 'Diamond balance',
  'my.earning.daimonds': 'diamonds',
  'my.earning.withdrawal.rules': 'Withdrawal Rules',
  'my.earning.salary.rules': 'Salary Rules',
  'ranking.daily': 'Daily',
  'ranking.weekly': 'Weekly',
  'ranking.contributed': 'Contributed:',
  'ranking.blank.daily': 'No one has sent gifts today',
  'ranking.blank.weekly': 'No one has sent gifts this week',
  'lucky.packet.title': 'Lucky packet',
  'lucky.packet.1': 'Send lucky packet',
  'lucky.packet.2': 'All users in the room can send and claim lucky packet',
  'lucky.packet.3': 'When there are many lucky packets in a room, they will be stacked and displayed. The earlier the lucky packets are sent, the more shown at the top.',
  'lucky.packet.4': 'Restrictions and Conditions',
  'lucky.packet.5': '1.Only supports sending coins.',
  'lucky.packet.6': '2. People Range: 3~500.',
  'lucky.packet.7': '3.The per capita amount (amount of coins/number of people) needs to be more than or equal to 1 coins.',
  'lucky.packet.8': '4.When the amount of the packet is more than 10000 coins and the number of people is more than 10 will trigger world notification, and a special icon will be displayed in the room list.',
  'lucky.packet.9': 'How to play',
  'lucky.packet.10': '1.Lucky packet with password\n-You need to send the password in the room to grab it.',
  'lucky.packet.11': '2.Lucky packet requires followers \n-You need to follow the lucky packet sender to grab it.',
  'lucky.packet.12': 'Common Issues',
  'lucky.packet.13': '1.When the packet triggers the world notification or when the lucky packet icon is displayed, other people can enter your room by clicking on it.',
  'lucky.packet.14': '2.If you locked your room, the world notification and icon will not appear.',
  'efficient_text_2': 'Effective time',
  'efficient_text_5': 'Effective day',
  'efficient_text_6': '1. Valid time in the room',
  'efficient_text_7': 'In the voice room, the time on the mic - the time off the mic> = %$ min is an effective time on the mic. We encourage the person on the mic to take the initiative to chat and interact with good friends for a long time, such as:',
  'efficient_text_8': 'Time on the mic',
  'efficient_text_9': 'Time off the mic',
  'efficient_text_10': 'Whether reached the standard',
  'efficient_text_11': 'Explain',
  'efficient_text_12': 'Reach the standard',
  'efficient_text_13': 'Did not reach the standard',
  'efficient_text_14': 'If time on the mic lasts till the next day, it is counted as the time for the previous day',
  'efficient_text_15': 'Time off the mic -Time on the mic <%$min',
  'efficient_text_16': 'Time off the mic-Time on the mic> = %$min',
  'efficient_text_17': '12/1 9:00:00 Time on the mic did not reach the standard, it cannot be counted as an effective time',
  'efficient_text_18': '12/1 23:00:00 Time on the mic continued till 12/2 and lasted 90 min in a row, so it is counted as time during 12/1',
  'efficient_text_19': '2. Effective days of the room',
  'efficient_text_20': 'In the voice room, all the effective durations are added during the day> = %$ min is an effective day. The higher the valid number of days, the higher the activity, and the activity rate directly affects the rewards you get.',
  'efficient_text_21': 'Total effective time',
  'efficient_text_22': '12/1 3 times on the mic during the day: 15min +35min +90min. Because 15 min does not meet the standard, the valid time = 90 +35 = 125min = 02H 05min',
  'efficient_text_23': '12/1 The valid duration of the day in total = 02H 05min> = %$min, which is counted as a valid day',
  'efficient_text_24': '3. Time on the mic',
  'efficient_text_25': 'The time on the mic must be effective time, and the effective time must be> = %$min. The time on the mic only indicates the time of chatting on the mic in the room. It will be considered as an effective time when the time on the mic> = %$min, such as:',
  'efficient_text_26': '4. Data details',
  'efficient_text_27': 'The data will be displayed according to the selected cycle',
  'efficient_text_28': 'Diamonds',
  'efficient_text_29': 'Chat',
  'efficient_text_30': 'Voice Room',
  'efficient_text_31': 'Details',
  'efficient_text_32': 'Date',
  'efficient_text_33': 'Time on the mic',
  'efficient_text_34': 'Effective time of the Voice Room',
  'efficient_text_35': 'Effective days of the Voice Room',
  'share_text23': 'Download',
  'share_text24': 'Join the room',
  'share_text25': 'I\'m in this room, come and join us',
  'share_text26': 'Room ID',
  'OfficialTask_Card_common_text1': 'Official Task',
  'OfficialTask_Card_common_text2': 'After completing the official reward task, you can get maximum {%s} diamonds!',
  'OfficialTask_dailyCard_text1': 'Daily diamond income rewards ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'Daily diamond income ({%s1}) reaches {%s2} 💎, get {%s3} 💎',
  'OfficialTask_dailyCard_text3': 'Daily diamond income rewards ({%s3}) reaches {%s1} 💎, get {%s2} 💎',
  'OfficialTask_dailyCard_text4': 'Reward Time',
  'OfficialTask_dailyCard_text5': 'Go',
  'OfficialTask_PeriodCard_text1': 'Work Period Diamond Reward ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'Work period diamond reward ({%s3})reaches {%s1} 💎, get {%s2} 💎',
  'OfficialTask_ActiveCard_text1': 'Work period active reward',
  'OfficialTask_ActiveCard_text2': 'Cumulative login in the cycle {%s1} days ({%s2}/{%s3})',
  'OfficialTask_ActiveCard_text3': 'If daily diamond income reaches {%s1} 💎, and you can get {%s2} 💎. (Today: {%s3}/{%s4})',
  'OfficialTaskPic_Level_text1': 'Daily Diamond Income Rewards (IM Message)',
  'OfficialTaskPic_Level_text2': 'Level',
  'OfficialTaskPic_Level_text3': 'Diamond Target',
  'OfficialTaskPic_Level_text4': 'Diamond Reward',
  'OfficialTaskPic_Level_text5': 'Daily Diamond Income Rewards（Voice room gifts : normal voice room + family voice room)',
  'OfficialTaskPic_Level_text6': 'Work Period Diamond Income Rewards (IM message + all gifts received)',
  'OfficialTaskPic_Level_text7': 'Work Period Active Rewards',
  'OfficialTaskPic_Level_text8': 'Log in for {%s1} days and get {%s2} diamonds every day',
  'OfficialTaskPic_Level_text9': 'Requirement',
  'OfficialTaskPic_Level_text10': 'Diamond Reward',
  'OfficialTaskPic_Level_text11': 'Notice：',
  'OfficialTaskPic_Level_text12': '1. Voice room gift: including normal voice room and family voice room;',
  'OfficialTaskPic_Level_text13': '2. Work period active reward: After the period ends, the number of active days will be counted, and the maximum reward you can get is 350 diamonds;',
  'OfficialTaskPic_Level_text14': '3. All diamond rewards will be sent directly to your account during this work period;',
  'OfficialTaskPic_Level_text15': '4. Every 100 diamonds = 1 USD',
  'OfficialTaskPic_Level_text16': 'Daily reward (for gifts in chats, audio- and video calls, audio match)',
  'OfficialTaskPic_Level_text17': 'If you receive diamonds for gifts in chats, audio-and video calls, audio match and meet the daily target, you will receive the corresponding diamond reward. Diamond rewards will be added to your acount the following day automatically.',
  'OfficialTaskPic_Level_text18': 'Daily reward (for gifts in chats and voice rooms)',
  'OfficialTaskPic_Level_text19': 'Work period reward (for audio- and video calls)',
  'OfficialTaskPic_Level_text20': '1. If you receive diamonds for gifts in chats and voice rooms and meet the daily target, you will receive the corresponding diamond reward. Diamond rewards will be added to your acount the following day automatically.',
  'OfficialTaskPic_Level_text21': '2. If you receive diamonds for audio- and video calls and meet the target by the end of the work period, you will receive the corresponding diamond reward. Diamond rewards will be added to your acount the following day after the end of the work period automatically.',
  'OfficialTaskPic_Level_text22': '3. There are 2 work periods that last from the 1st till 15th of each month, and from 16th till 30th/31st of each month.',
  'OfficialTaskPic_Level_text23': 'Daily reward 1 (Audio Party Room & Family Gift Diamond)',
  'OfficialTaskPic_Level_text24': 'Daily reward 2 (Voice Call, Voice Match Diamond)',
  'OfficialTaskPic_Level_text25': 'Work Period Reward ( Chat, Audio Party Room, Voice Calls, Audio Match)',
  'OfficialTaskPic_Level_text26': '1. If you receive diamonds for gifts in chats, audio room and video calls, audio match and meet the weekly target, you will receive the corresponding diamond reward. Diamond rewards will be added to your acount in this salary term automatically.',
  'OfficialTaskPic_Level_text27': '2. Salary Rate: 100 Diamond=1 USD;',
  'OfficialTaskPic_Level_text28': '3. The diamonds got from daily rewards will not be counted to this diamond target;',
  'OfficialTaskPic_Level_text29': 'Soyou official reward system 02.2024',
  'OfficialTaskPic_Level_text30': 'Daily task 1: All calls + all gifts',
  'OfficialTaskPic_Level_text31': 'Daily Mission 2: Message Reply',
  'OfficialTaskPic_Level_text32': 'Daily Diamond Target',
  'OfficialTaskPic_Level_text33': 'Our daily diamond target is shown above, and one day in our reward system is based on Turkish local time.',
  'cms_report_text3': 'Report reason:',
  'cms_report_text4': 'Report details:',
  'cms_report_text5': 'Report screenshot:',
  'cms_report_text6': '*Please verify the above information, so we can apply penalty for information.',
  'cms_report_text7': 'Reporter Showid:',
  'cms_report_text8': 'The reporter Showid:',
  'cms_report_text9': 'Penalty method:',
  'cms_report_text10': 'Penalty result:',
  'cms_report_text11': 'Punishment history',
  'cms_report_text12': 'Verbal warning',
  'cms_report_text13': 'Banning method:',
  'cms_report_text14': 'Reasons for banning:',
  'cms_report_text15': 'Banning time:',
  'cms_report_text16': 'Political sensitivity',
  'cms_report_text17': 'Vulgar',
  'cms_report_text18': 'Attack and abuse',
  'cms_report_text19': 'Bloody violence',
  'cms_report_text20': 'Advertising',
  'cms_report_text21': 'Suspected fraud',
  'cms_report_text22': 'Illegal information',
  'cms_report_text23': 'Minor',
  'cms_report_text24': 'Other',
  'cms_report_text25': 'Confirmation',
  'cms_report_text26': 'Account sensitive operation, please confirm the information after the information',
  'OfficialTask_dailyCard_text6': 'Completed',
  'OfficialTask_rewardTime_text1': 'hours',
  'OfficialTask_rewardTime_text2': 'minutes',
  'delete_account_web_title': 'Dear Soyou User. Thanks for using and supporting our product. If you would like to delete your account, please check following steps to process:',
  'delete_account_web1': '1. Open Application and enter main page, click the bottom right to enter Me Tab.',
  'delete_account_web2': '2. Click settings after entering Me Tab.',
  'delete_account_web3': '3. Click delete account after entering settings.',
  'delete_account_web4': '4. Confirm first step for permanently delete account.',
  'delete_account_web5': '5. Confirm second step for cannot login use same account.',
  'delete_account_web6': '6. Confirm last step for deleting all corresponding personal information.',
  'delete_account_web7': '7. After finishing all steps above. Your account has been deleted successfully, with all your personal information and account data. Our platform will no longer keep your data in our database.',
  'delete_account_web': 'Delete Account',
  'svip_introduce_1': '1.What is SVIP',
  'svip_introduce_text1': 'SVIP is the distinguished level system of the platform. There are 8 levels in total, SVIP1-SVIP8. The higher the level, the more distinguished the status, and the more advanced rights and interests you enjoy.',
  'svip_introduce_2': '2. How to become a SVIP',
  'svip_introduce_text2': 'You can get SVIP experience points by recharging gold coins, 1 gold coin = 1 experience point. When the experience points reach different levels of SVIP, you can obtain the corresponding SVIP level.',
  'svip_introduce_3': '3. How to calculate the validity period of SVIP',
  'svip_introduce_text31': 'SVIP takes each natural month as a cycle, and on the 1st of each natural month, SVIP experience points are accumulated from 0. The corresponding SVIP level will be obtained according to the level reached by the SVIP experience value.',
  'svip_introduce_text32': 'From the time you obtain SVIP status, your status and privileges will be retained until the end of the next month. (For example: if SVIP3 is reached on May 18, then the SVIP3 status will be extended to June 30.)',
  'svip_introduce_text33': 'If your SVIP experience value reaches a higher level within a natural month, it will be upgraded immediately. (For example: if you reach SVIP3 on May 18th and SVIP4 on May 25th, you will immediately obtain SVIP4 status on May 25th and continue until the end of June 30th.)',
  'svip_introduce_text34': 'When the natural month ends, the identity and privileges will be retained, but the SVIP experience points for the next month will be accumulated from 0. (For example: If you reach SVIP4 on May 25, you will still enjoy the identity and rights of SVIP4 throughout June, but you will start to accumulate SVIP experience points from 0 in June)',
  'svip_introduce_4': '4.SVIP’s relegation and downgrade',
  'svip_introduce_text41': 'At the beginning of each natural month, if you have a SVIP level and want to retain this SVIP level in the next month, you need to reach 50% of the SVIP level experience value before the end of the natural month, that is, you can retain this level in the next month, retain the identity and rights. (For example: when May starts, you are SVIP4, then you only need to reach 50% of the experience value of the SVIP4 level throughout May to retain the SVIP4 level until the end of June.)',
  'svip_introduce_text42': 'If 50% of the SVIP level experience value is not reached within a natural month, it will be reduced by 1 level in the next month. (For example: at the beginning of May, you are SVIP4, and the experience value in the entire May does not reach 50% of the SVIP4 level, then June will drop by 1 level, starting from SVIP3.)',
  'noble_introduce_title': 'Introduction to Aristocracy Rules',
  'noble_introduce_welcome': 'Welcome to join our aristocratic system! Becoming an aristoctat will allow you to enjoy more unique privileges and benefits. The following is a helpful introduction to our aristocratic system:',
  'noble_introduce_1': '1.What is Aristocracy?',
  'noble_introduce_text1': 'Aristocracy is a special status symbol and is divided into seven status levels, namely knight, baron, viscount, earl, marquis, duke and king. Different levels of aristocracy enjoy different privileges.',
  'noble_introduce_2': '2.How to become an aristocrat',
  'noble_introduce_text2': 'Aristocracy can be purchased by recharging gold coins, and the purchase can be completed by selecting the corresponding level on the Aristocracy page. At the same time, you can also obtain aristocratic status through gifts from others.',
  'noble_introduce_3': '3. Validity period calculation',
  'noble_introduce_text3': 'The aristocratic status is valid for 30 days from the date of purchase, and you will enjoy aristocratic privileges during the validity period. The privileges will expire at the end of the validity period.',
  'noble_introduce_4': '4. Daily coin delivery instructions',
  'noble_introduce_text4': 'After purchasing Aristocracy through gold coins, you are eligible to receive gold coins as gifts every day. You will receive gold coins after signing in every day. If you do not sign in on that day, you will not be able to obtain the gold coins for that day. When gifting Aristocracy to others, the recipient will receive the right to receive daily coins.',
  'noble_introduce_5': '5. Continuous purchase discounts',
  'noble_introduce_text5': 'During the period of obtaining aristocratic status, and within 10 days after the aristocratic status expires, the same aristocratic status can be purchased again at a more favorable price. This plan is not automatic and requires you to purchase it manually to take effect.',
  'noble_introduce_6': '6. Upgrading of Aristocracy',
  'noble_introduce_text6': 'When you already have aristocratic status, you can purchase a higher-level Aristocracy and directly obtain the latest benefits. The remaining days of the existing Aristocracy will be merged into the latest level according to the remaining value, and the validity period of the new aristocratic level will be extended.',
  'noble_introduce_7': '7. Sending Aristocracy as a gift',
  'noble_introduce_text7': 'When giving Aristocracy to another person, the original price will be given to the other person, and the recipient will enjoy daily coins and other rights corresponding to the level. If the recipient already has aristocratic status, he will directly enjoy the high-level aristocratic status, and other levels will be converted according to the corresponding duration.',
  'vip_introduce_title': 'Introduction to VIP rules',
  'vip_introduce_welcome': 'Welcome to become a VIP! VIP will allow you to enjoy more privileges. The following is a help introduction about VIP:',
  'vip_introduce_1': '1.What is VIP',
  'vip_introduce_text1': 'VIP is a user growth system. There are currently 16 levels, VIP1-VIP16. The higher the VIP level, the more rights you will enjoy and the richer the props.',
  'vip_introduce_2': '2.How to become a VIP',
  'vip_introduce_text2': 'You can get VIP experience points by recharging gold coins, 1 gold coin = 1 experience point. The more gold coins you recharge, the more experience points you get, and the VIP will rise to a higher level.',
  'vip_introduce_3': '3.VIP validity period',
  'vip_introduce_text3': 'Once the VIP status is obtained, it is permanently valid and the VIP experience points are accumulated permanently and will not be cleared. As experience points increase, you will be promoted to a higher VIP level and enjoy more level benefits.',
  'vip_introduce_4': '4. Use of VIP props',
  'vip_introduce_text4': 'The VIP level props you obtain will always be stored in your backpack and can be worn at any time. When you upgrade, the low-level props you have obtained can still be used.',
  'svip_introduce_title': 'Introduction to SVIP rules',
  'svip_introduce_welcome': 'Welcome to become SVIP! SVIP will allow you to enjoy more privileges. The following is a helpful introduction to SVIP:',
  'svip_introduce_text43': 'If no SVIP experience points are generated within a natural month, the SVIP level will drop by 3 levels in the next month. (For example: when May starts, you are SVIP4, and no experience points are generated throughout May, then June will drop by 3 levels, starting from SVIP1)',
  'svip_introduce_5': '5. SVIP’s rights and interests',
  'svip_introduce_text5': 'The higher the SVIP level, the more rights you enjoy. When the level changes, you will enjoy the benefits of the new level, and the prop rewards you receive will be overwritten by the new level. When upgrading or maintaining customized props, you need to contact customer service yourself and put forward customization requirements before they are issued. However, they will not be issued if you downgrade.',
  'svip_table1': 'SVIP level',
  'vip_table1': 'VIP level',
  'svip_table2': 'Free message',
  'svip_table3': 'Free calls',
  'Anonymity_name': 'Anonymity',
  'Noble_Change_2': 'Purchase Conditions: Lower ranks can buy higher ranks, but higher ranks cannot buy lower ranks. For example, if you are currently a Count, you can only purchase Marquis, Duke, or King.',
  'Noble_Change_3': 'Conversion Logic: If you are already an aristocrat, after purchasing another aristocratic rank, the remaining validity period of the old aristocratic rank will be converted to the new aristocratic rank based on the coin price ratio, and the old aristocratic rank will become invalid.',
  'Noble_Change_4': 'Validity Period Calculation Formula: New purchased aristocracy validity period = current aristocratic rank remaining days * (current aristocratic rank price / purchased aristocratic rank price) + 30, the final number of days is rounded down.',
  'Noble_Change_5': 'Example: If you are currently a Viscount (99990 coins/month), with 13 days left, and you purchase a Count (199990 coins/month) today, then after payment, the Count\'s validity period will be 13 * (99990/199990) + 30 = 6.5 rounded down + 30 = 36 days.',
  'rich_list': 'Rich Ranking',
  'lucky_list': 'Lucky Ranking',
  'lucky_daily': 'Daily',
  'lucky_weekly': 'Weekly',
  'lucky_faq1': 'How to play',
  'lucky_faq2': 'Game Rules',
  'lucky_faq3': '1. After giving a lucky gift, you have a chance to get 1-1000 times the gold coin reward;',
  'lucky_faq4': '2. The more lucky gifts you send in Combo or Batch, the greater the chance of winning;',
  'lucky_faq5': '3. Gold coin rewards will be distributed to the account balance in real time, and winning details can be viewed in the lucky gift record;',
  'lucky_faq6': '4. Every time a lucky gift is given, the anchor will also receive a certain proportion of diamonds.',
  'lucky_faq7': 'Ranking Rules',
  'lucky_faq8': '1. Statistical Rules',
  'lucky_faq9': 'The ten users who spend the most gold coins participating in the daily and weekly gameplay will be on the rich ranking, and the ten users with the highest winning multiples will be on the lucky ranking.',
  'lucky_faq10': '2. Statistical Cycle',
  'lucky_faq11': 'Daily ranking: data from 0:00 to 24:00 every day',
  'lucky_faq12': 'Weekly ranking: data from 0:00 every Monday to 24:00 Sunday',
  'lucky_faq13': '3. Ranking Rewards',
  'lucky_faq14': 'The top ten on the daily and weekly rankings will receive rewards as shown below',
  'lucky_faq15': 'Daily ranking rewards',
  'lucky_faq16': 'Ranking',
  'lucky_faq17': 'Weekly ranking rewards',
  'Charge_Same_1': 'You have sent the same amount of recharge to this user recently and the transaction was successful. Do you want to proceed again?',
  'Charge_Same_2': 'Cancel Payment',
  'Charge_Same_3': 'Proceed with Payment',
  'Registr_optimization_1': 'Registration and login issues',
  'AnchorCenter_biList_interaction_text1': 'Interaction',
  'AnchorCenter_biList_interaction_text2': 'Initiated Chats (UV)',
  'AnchorCenter_biList_interaction_text3': 'Reply Rate (UV)',
  'AnchorCenter_biList_interaction_text4': 'Reply Rate (PV)',
  'AnchorCenter_biList_interaction_text5': 'Response Rate (UV)',
  'AnchorCenter_biList_interaction_text6': 'Messages Received (UV)',
  'AnchorCenter_biList_interaction_text7': 'Messages Replied (UV)',
  'AnchorCenter_biList_interaction_text8': 'Response Rate (UV)',
  'AnchorCenter_biList_interaction_text9': 'Messages Sent (UV)',
  'AnchorCenter_biList_interaction_text10': 'Your Messages Replied (UV)',
  'AnchorCenter_biList_interaction_text11': 'Reply Rate (UV)',
  'AnchorCenter_biList_interaction_text12': 'Messages Sent (PV)',
  'AnchorCenter_biList_interaction_text13': 'Your Messages Replied (PV)',
  'AnchorCenter_biList_interaction_text14': 'Reply Rate (PV)',
  'AnchorCenter_biList_interaction_Popup1': 'You received messages from \'x\' users',
  'AnchorCenter_biList_interaction_Popup2': 'You replied to \'n\' out of \'x\' users who messaged you',
  'AnchorCenter_biList_interaction_Popup3': 'Example: You received messages from 100 users, and you effectively replied to 90 of them. Your effective reply rate (UV) = 90/100 = 90%',
  'AnchorCenter_biList_interaction_Popup4': 'Message Reply Percentage (UV)',
  'AnchorCenter_biList_interaction_Popup5': 'Effective Reply Rate: Only counts users who were replied to before timeout',
  'AnchorCenter_biList_interaction_Popup6': 'Got it',
  'AnchorCenter_biList_interaction_Popup7': 'You sent messages to \'x\' users',
  'AnchorCenter_biList_interaction_Popup8': 'Out of \'x\' users you messaged, \'n\' replied to you',
  'AnchorCenter_biList_interaction_Popup9': 'Percentage of Users Who Replied (UV)',
  'AnchorCenter_biList_interaction_Popup10': 'Example: You sent messages to 100 users, and 50 of them replied. Your effective reply rate (UV) = 50/100 = 50%',
  'AnchorCenter_biList_interaction_Popup11': 'Effective Reply Rate: Only counts replies received before timeout',
  'AnchorCenter_biList_interaction_Popup12': 'You sent \'x\' messages',
  'AnchorCenter_biList_interaction_Popup13': 'Out of \'x\' messages you sent, \'n\' were effectively replied to',
  'AnchorCenter_biList_interaction_Popup14': 'Percentage of Your Messages Replied (PV)',
  'AnchorCenter_biList_interaction_Popup15': 'Example: You sent 100 messages, and 70 of them were effectively replied to. Your effective reply rate (PV) = 70/100 = 70%',
  'AnchorCenter_biList_interaction_Popup16': 'Effective Reply Rate: Only counts replies received before timeout',
  'program_list_24_ios': 'Delete',
  'withdraw_text_26': 'Please verify the correct payment information. Incorrect information will result in withdrawal failure, and additional fees will be borne by the user.',
  'withdraw_text_29': 'Tip:',
  'withdraw_text_43': 'There are unfinished orders for this payment method and cannot be modified or deleted temporarily.',
  'withdraw_text_44': 'Submitted successfully!',
  'payment_bind_2': 'Bank card',
  'payment_bind_2_GPAY': 'Bank card',
  'payment_bind_3': 'Bank name',
  'payment_bind_4': 'Name',
  'payment_bind_5': 'Mail',
  'payment_bind_6': 'Address',
  'payment_bind_7': '10 digits or PL plus 10 digits',
  'payment_bind_8': 'Starts with TR + 24 digits',
  'payment_bind_9': '{n} Must',
  'payment_bind_10': 'Delete successful',
  'payment_bind_11': 'First name/Given name',
  'payment_bind_12': 'Last name/Surname',
  'Tvwall_gift_9': 'Complete gift wishlists worth more than or equal to 2,000 coins to be displayed on the TV wall',
  'Tvwall_gift_10': 'Entry lock screen conditions:',
  'Tvwall_gift_32': 'Should giving gifts be shown on TV?',
  'Tvwall_gift_33': '(Click to select to take effect immediately)',
  'Tvwall_gift_11': 'Lock screen for 10 seconds: a wish gift is completed and the value of the wish gift is between 2000 coins and 9999 coins;',
  'Tvwall_gift_12': 'Lock screen for 20 seconds: Completed a wish gift and the value of the wish gift is between 10,000 coins and 49,999 coins;',
  'Tvwall_gift_13': 'Lock screen for 60 seconds: Completed a wish gift and the value of the wish gift is more than 50,000 coins',
  'Tvwall_gift_14': 'Conditions for appearing on the World TV Wall:',
  'Tvwall_gift_15': 'Ordinary record: Completed a wish gift and the value of the wish gift is between 2000 coins and 9999 coins',
  'Tvwall_gift_16': 'Luxurious record: Completed a wish gift and the value of the wish gift is greater than or equal to 10,000 coins',
  'Tvwall_gift_17': 'On the TV wall',
  'Tvwall_gift_18': 'Anonymous on the TV wall',
  'Tvwall_gift_19': 'Not on the TV wall',
  'Admob_text7': 'In preparation',
  'Admob_text8': 'Video is not ready yet',
  'EXP': 'EXP',
  'Terms of Service': 'Terms of Service',
  'Privacy Policy': 'Privacy Policy',
  'Experience_Card_Statement': '*Experience cards do not have this benefit',
  'Official_website_payment_1': 'Soyou Online Recharge',
  'Official_website_payment_2': 'Recharge ID',
  'Official_website_payment_3': 'Enter the ID',
  'Official_website_payment_4': 'what is ID？',
  'Official_website_payment_5': 'Please check first to protect account\'s privacy and security.',
  'Official_website_payment_6': 'Query',
  'Official_website_payment_7': 'Notice to Users',
  'Official_website_payment_8': '1.Don\'t purchase Soyou coins through unofficial or unauthorized websites to avoid unnecessary disputes.',
  'Official_website_payment_9': '2.Don\'t trust any unofficial information posted on other websites, communication channels or communication groups. All event information is subject to official announcement via the official website or in-system notice.',
  'Official_website_payment_10': '3.Any offline transactions are not supported.',
  'Official_website_payment_11': '4.Don\'t disclose your account information to anyone else for any reason or in any method.',
  'Official_website_payment_12': '5.Soyou shall not be held liable for any disputes between Users and the third party.',
  'Official_website_payment_13': '6.If there\'s any problem with recharging,please contact customer service or Email us.',
  'Official_website_payment_14': 'Anti-money Laundering',
  'Official_website_payment_15': '1.The user must ensure that you have a legal identity and capacity to use the services provided by us and will not participate in or be associated with any criminal activity.',
  'Official_website_payment_16': '2.The user account is for your exclusive use and belongs to you alone. You may not transfer, rent or otherwise dispose of your account to any third party.',
  'Official_website_payment_17': '3.The user must ensure that all money used for recharges is obtained through legal means and is not at any time associated with criminal activity or behavior.',
  'Official_website_payment_18': 'Method of Payment',
  'Official_website_payment_19': 'Currently using {%s} payment channel',
  'Official_website_payment_20': 'Recharge Option',
  'Official_website_payment_21': 'Change',
  'Official_website_payment_22': 'Account ID does not exist!',
  'Official_website_payment_23': 'No supported payment methods yet',
  'Official_website_payment_24': 'Feedback your desired payment method',
  'Official_website_payment_25': 'Querying transaction results',
  'Official_website_payment_26': 'Recharge result to be confirmed',
  'Official_website_payment_27': 'The recharge result may be delayed. Please enter the App to check the account recharge record. If the account does not arrive for a long time, please contact customer service.',
  'Official_website_payment_28': 'Refresh',
  'Official_website_payment_29': 'Recharge failed',
  'Official_website_payment_30': 'Help information:',
  'Official_website_payment_31': '1. Please confirm whether the amount and payment method are correct, including personal information, credit card number, validity period, CVV code, etc.',
  'Official_website_payment_32': '2. Please check whether the account balance is sufficient.',
  'Official_website_payment_33': '3. Check whether the network connection is stable. Sometimes network problems may cause payment failure.',
  'Official_website_payment_34': '4. Try changing to other payment methods or try recharging later.',
  'Official_website_payment_35': '5. If the problem is still not resolved, it is recommended to contact the customer service of the recharge platform for further help.',
  'Official_website_payment_36': 'Recharge successful',
  'Official_website_payment_37': 'Please enter the App to view the account recharge record',
  'Official_website_payment_38': 'Link timeout fails',
  'Official_website_payment_39': 'The link has expired. Please re-create the payment link in the App.',
  'payment_bind_13': 'Contract Address',
  'payment_bind_14': 'Epay Email',
  'payment_bind_15': 'Note: TRC-20 protocol',
  'payment_bind_16': 'Note: Ensure your Epay account is verified',
  'payment_bind_17': 'Contract address starts with T',
  'payment_bind_18': 'Cannot exceed 40 characters',
  'payment_bind_19': 'Must match your Epay account email',
  'payment_bind_20': 'Enter email address',
  'payment_bind_21': 'Gcash account',
  'payment_bind_22': 'Must be 11 digits starting with 09',
  'payment_bind_23': 'Only allow English letters, spaces, hyphens (-), periods (.), and commas (,) and less than 100 characters.',
  'payment_bind_24': 'Bank Tansfer account',
  'payment_bind_25': 'Pix Key (CPF/CNPJ)',
  'payment_bind_26': 'Document',
  'payment_bind_27': 'Only 11 digits are allowed',
  'task_miss': 'miss',
  're_signing': 'Re-signing',
  'anchor_task_txt1': 'Visit old friends (and get replies from them) for {%s1} times and get {%s2} 💎',
  'anchor_task_txt2': 'The number of sessions with new users > 5 reaches {%s1} times, get {%s2} 💎',
  'task_txt21': 'Daily check-in',
  'task_txt22': 'day',
  'task_txt23': 'Sign in',
  'task_txt24': 'task list',
  'task_txt25': 'Anchor tasks',
  'task_txt31': 'Signed in',
  'sign_in_text3_new': 'Sign-in 2x the reward',
  'Double_Rewards_text1': 'Become SVIP for Double Rewards!',
  'family.level.instructions': 'FAMILY LEVEL INSTRUCTIONS',
  'family.division.privilege': 'Division & Division Privilege',
  'family.division.privilege.describe': 'Division is based on monthly exp, resetting on the 1st of each month. Division can upgrade, retain and downgrade. Retain of current rank only requires achieving 100% of the corresponding upgrade exp.',
  'family.diamonds.exch': 'Diamonds Exch.',
  'family.new.diamonds.exch': 'Badge',
  'family.label.tag': 'Famliy Tag',
  'family.label.frame': 'Family Frame',
  'family.label.chatroom': 'Chatroom Bg',
  'family.label.familyBg': 'Family Bg',
  'family.bronze.family': 'Bronze Family',
  'family.silver.family': 'Silver Family',
  'family.golden.family': 'Golden Family',
  'family.diamond.family': 'Diamond Family',
  'family.king.family': 'King Family',
  'family.task.daily.exp': 'DAILY EXP',
  'family.task.monthly.exp': 'MONTHLY EXP',
  'family.task.exp.describe': 'The EXP you contribute to the family',
  'family.task.tips': 'Complete tasks within the first 2 days of joining the Family to gain double experience.',
  'family.task.invite.join': 'Invite Friends to Join the Family',
  'family.task.treasure.unlocked': 'If the number of members reaches %s, the family treasure chest will be unlocked at 0 a.m. everyday.',
  'family.task.your.rewards': 'Your Rewards',
  'family.task.rules.first': 'After meeting the conditions of the family treasure chest, the rewards in the treasure chest will be opened randomly.',
  'family.task.rules.second': 'Members who complete the task before the treasure chest is opened will receive rewards.',
  'family.task.rules.three': 'Items will be distributed to Winners Bag, and other rewards such as EXP or coins will be distributed to accounts.',
  'family.task.rules.four': 'Rewards will be automatically distributed after the treasure chest is opened.',
  'family.task.captain.task': 'Captain Task',
  'family.task.treasure.chest': 'Family Treasure Chest',
  'family.task.interactive': 'Interactive Task',
  'family.task.cumulative': 'Cumulative Task',
  'family.task.others': 'Others',
  'family.task.family.level': 'Family Level is based on accumulated exp. Each level corresponds to the following privilege.',
  'family.exp.title': 'Family Experience',
  'family.exp.content.title.1': 'How to obtain Family EXP？',
  'family.exp.content1.text.title.1': 'Family members send gifts',
  'family.exp.content1.text.1': '{%s1} Coin',
  'family.exp.content1.text.2': '1 Exp',
  'family.exp.content1.text.3': '50 Gem',
  'family.exp.content1.text.title.2': 'Family members receive gifts',
  'family.exp.content1.text.title.3': 'Complete family tasks',
  'family.exp.content.title.2': 'Family Level & level Privilege',
  'family.exp.table.title.1': 'Exp',
  'family.exp.table.title.2': 'Member',
  'family.exp.table.title.3': 'Co-Captain',
  'family.exp.table.title.4': 'Admin',
  'common.EXP': 'EXP',
  'game.task.center.get': 'Get',
  'game.task.center.received': 'Received',
  'coupon_pay_txt4': 'coins',
  'iosso_wallet_txt7': 'It will return to Wallet in {%s} seconds.',
  'coupon_pay_txt2': 'Only for {%s}',
  'coupon_pay_txt3': '{%s}% Coins Coupon',
  'iosso_wallet_txt8': 'Go Back',
  'recharge.event.Recharge': 'Recharge',
  'recharge.event.hidden': 'Hide information',
  'lucky.draw.tab.ranking': 'Ranking',
  'lucky.draw.exchange.shop': 'Ticket Shop',
  'lucky.draw.exchange.shop.val': 'Coins value{%d}',
  'lucky.draw.exchange.shop.exchange': 'exchange',
  'lucky.draw.my.times': 'My times',
  'lucky.draw.rare': 'Rare',
  'lucky.draw.exchange.records': 'Records',
  'lucky.draw.exchange.records.time': 'time',
  'lucky.draw.exchange.records.consume': 'consume',
  'lucky.draw.exchange.records.commodity': 'commodity',
  'lucky.draw.confirm': 'Please confirm',
  'lucky.draw.confirm.text': 'Are sure to expend TicketX{%d} to exchange?',
  'lucky.draw.confirm.success': 'successfully',
  'lucky.draw.rules.1': 'At the end of the event, the top three winners will receive the following prizes',
  'lucky.draw.rules.2': 'note: At the end of the campaign, the number of unused prizes will become 0',
  'lucky.vs.camp.select': 'Camp Selection',
  'lucky.vs.camp.select.text.1': 'Top 5 contributors of the winning camps can get coins rewards!',
  'lucky.vs.camp.select.text.2': 'Which camp do you want to join?',
  'lucky.vs.camp.select.text.3': 'TIPS: Each person can only change the camp once during the event time.',
  'lucky.vs.camp.edit.text.1': 'Change Camp',
  'lucky.vs.camp.edit.text.2': 'Are you sure you want to change the camp?Each person can only change the camp once.',
  'lucky.vs.camp.edit.text.3': 'YES',
  'lucky.vs.camp.edit.text.4': 'NO',
  'lucky.vs.camp.opponent': 'Opponent\'s Camp',
  'lucky.vs.camp.me': 'Our Camp',
  'lucky.vs.camp.join': 'Join',
  'lucky.vs.camp.Eagle': 'Eagle Ranking',
  'lucky.vs.camp.Lion': 'Lion Ranking',
  'lucky.vs.out.tab.left': 'Treasure Box',
  'lucky.vs.out.tab.right': 'Eagle VS Lion',
  'lucky.vs.reward.extra': 'Eagle VS Lion Bonus',
  'lucky.vs.ext.text.tip': 'Reach {N} coins can get the following rewards.',
  'kill.monster.congratulations': 'Congratulations!',
  'activity.gift.list.contributor': 'Contributor\nRanking',
  'activity.gift.list.stars': 'Stars\nRanking',
  'activity.gift.list.receive': 'Stars',
  'common.cap.Rights': 'All Rights Reserved By SOYO',
  'anchor.pk.countdown': 'Countdown',
  'anchor.pk.days': 'Days',
  'anchor.pk.hours': 'Hours',
  'anchor.pk.minutes': 'Minutes',
  'anchor.pk.seconds': 'Seconds',
  'anchor.pk.rules': 'Rules',
  'anchor.pk.rules.rewards': 'Rules&Rewards',
  'anchor.pk.sponsor': 'Today\'s Exclusive Sponsor',
  'anchor.pk.queen': 'Glamour Queen',
  'anchor.pk.exclusive.Sponsor': 'Exclusive Sponsor',
  'anchor.pk.daily.Ranking': 'Daily Ranking',
  'anchor.pk.total.Ranking': 'Total Ranking',
  'anchor.pk.PK.Times': 'PK Times',
  'anchor.pk.win.Times': 'Win Times',
  'anchor.pk.rank': 'Rank',
  'anchor.pk.target': 'Target',
  'anchor.pk.rewards': 'Rewards',
  'anchor.pk.duration': 'Duration',
  'anchor.pk.coins': 'Coins',
  'anchor.pk.tools.rewards': 'Tools Rewards',
  'anchor.pk.queen.daily.rewards': 'Glamour Queen Daily Ranking Rewards',
  'anchor.pk.queen.total.rewards': 'Glamour Queen Total Ranking Rewards',
  'anchor.pk.sponsor.daily.rewards': 'Exclusive Sponsor Daily Ranking Rewards',
  'anchor.pk.sponsor.total.rewards': 'Exclusive Sponsor Total Ranking Rewards',
  'anchor.pk.event.end': 'The event is over',
  'biu.biu.building.ranking.list': 'Ranking',
  'biu.biu.building.car.detail': 'Vehicle Details',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, you recharged {$coin} coins.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, you fought {$count} {$level} {$cars} and destroyed {$floornumer} {$floor}.',
  'biu.biu.building.rush.button': 'Go*{$times}',
  'biu.biu.building.can.rush.one': 'Remaining Rush Times: Level1 Car*{$times}',
  'biu.biu.building.can.rush.two': 'Level2 Car*{$times}',
  'biu.biu.building.one.car': 'Level1 Car',
  'biu.biu.building.two.car': 'Level2 Car',
  'biu.biu.building.to.war': 'Go',
  'biu.biu.building.recharge': 'Recharge {$value}coins/{$count} times',
  'biu.biu.building.daily.list': 'Daily Ranking',
  'biu.biu.building.all.list': 'Total Ranking',
  'biu.biu.building.car.not.enough': 'The current number of vehicles is insufficient',
  'biu.biu.building.to.get': 'to get',
  'biu.biu.building.congra': 'Congratulations!',
  'biu.biu.building.to.collect': 'OK',
  'biu.biu.building.get.reward': 'Your reward!',
  'biu.biu.building.ruls.reward': 'Rule&Rewards',
  'biu.biu.building.no.records': 'No records',
  'biu.biu.building.no.lucky': 'unlucky',
  'biu.biu.building.no.start': 'This stage is about to start',
  'biu.biu.building.floor.single': 'Floor',
  'biu.biu.building.floor.double': 'Floors',
  'biu.biu.building.car.single': 'Car',
  'biu.biu.building.car.double': 'Cars',
  'annual.ranking.surprise.store': 'Surprise Store',
  'annual.ranking.daily.task': 'Daily Task',
  'annual.ranking.ticket': 'Ticket',
  'annual.ranking.daily.ranking': 'Daily Ranking',
  'annual.ranking.total.ranking': 'Total Ranking',
  'annual.ranking.current.tickets': 'Current Tickets',
  'annual.ranking.points': 'Points',
  'annual.ranking.open': 'Open',
  'annual.ranking.collect': 'Collect',
  'annual.ranking.unfinished': 'Unfinished',
  'annual.ranking.exchange': 'Exchange',
  'annual.ranking.confirm': 'Confirm',
  'annual.ranking.to.bag': 'Exchanged items can be viewed in the bag',
  'annual.ranking.exchange.maximum': 'The exchange amount reached the maximum today',
  'annual.ranking.limited': 'Limited',
  'annual.ranking.slod.out': 'SOLD OUT',
  'annual.ranking.stock': 'Stock',
  'annual.ranking.return': 'Return',
  'annual.ranking.fortune.wheel': 'Fortune Wheel',
  'annual.ranking.record': 'Record',
  'annual.ranking.exchange.amount': 'Exchange Amount',
  'annual.draw.1.time': 'Draw {N} time',
  'annual.draw.10.time': 'Draw {N} times',
  'annual.draw.record.text': 'Congratulations! You have received',
  'annual.draw.pop.to.get': 'TO GET',
  'annual.draw.pop.no.times': 'Insufficient draw times',
  'annual.draw.pop.no.record': 'No record yet.',
  'annual.draw.pop.rewards.title': 'Congras!',
  'annual.draw.pop.oppos': 'Oppos!',
  'annual.ranking.union.achor': 'Annual Anchor',
  'annual.ranking.union.agency': 'Annual Agency',
  'annual.ranking.union.target': 'Target',
  'annual.ranking.task.confirm': 'Are you sure to enjoy {$count}x points mode now?',
  'annual.ranking.union.id': 'Agency ID:',
  'annual.ranking.icon': 'Icon',
  'annual.ranking.num': 'Numbers',
  'annual.ranking.success': 'Success',
  'diamond.tab.chat': 'chat',
  'diamond.tab.voice': 'Voice party',
  'common.cap.Follow': 'Follow',
  'gift.list.plus.up.need': 'Up need',
  'spring.cp.rewards.wedding.tips': 'The two user who are hosting the wedding can obtain the limited avater*30 days',
  'spring.cp.tab.rose.ranking': 'Rose Ranking',
  'spring.cp.tab.rose.ranking.daily': 'Daily ranking',
  'spring.cp.tab.rose.ranking.daily.toast': 'Date has not arrived',
  'spring.cp.tab.rose.ranking.daily.tips': 'Sending this gift could obtain {%d}% extra roses today',
  'spring.cp.tab.rose.ranking.total': 'Total ranking',
  'spring.cp.tab.cruise.ranking': 'Castle Wedding',
  'spring.cp.no.people': 'Waiting',
  'spring.cp.no.cp': 'You have not yet sent any Valentine\'s Day limited gifts to others.',
  'spring.cp.wait.wedding': 'The wedding will begin on February 15.',
  'spring.cp.cruise.rule.tips': 'The CP pair that earns the most roses by exchanging limited gifts during the event can hold a castle wedding on February 15.',
  'spring.cp.cruise.my.cp': 'my cp',
  'spring.cp.cruise.find.my.cp': 'Find my CP',
  'spring.cp.cruise.bless': 'Click to bless',
  'spring.cp.cruise.bless.my.times': 'my times',
  'spring.cp.cruise.bless.status.1': 'Received',
  'spring.cp.cruise.bless.status.2': 'Unclaimed',
  'spring.cp.cruise.bless.click.desc': 'Click {N} times will get {name} {time}',
  'common.cap.Start': 'Start',
  'common.cap.Close': 'Close',
  'common.cap.next.round': 'Next round will coming soon…',
  'ramadan.new.waiting': 'Waiting',
  'ramadan.new.rank.tab.receive': 'Charming Ranking',
  'ramadan.new.rank.tab.give': 'Wealth Ranking',
  'ramadan.new.rank.daily': 'Daily Ranking',
  'ramadan.new.rank.total': 'Total Ranking',
  'ramadan.new.rank.daily.desc': 'Daily TOP1 user can get corresponding rewards.',
  'ramadan.new.rank.tips': 'This stage is about to start',
  'ramadan.new.honor.times': '{n}times',
  'ramadan.new.honor.time': '{n}time',
  'ramadan.new.honor.countdown.waiting': 'Event is about to start',
  'ramadan.new.honor.countdown.ing': 'Countdown',
  'ramadan.new.honor.countdown.over': 'The event is over',
  'ramadan.new.honor.desc': 'Room honor pop-up will be triggered once for every {N} limited gifts across all platforms.',
  'ramadan.new.honor.toTop1.time': 'UP NEED <span class=\'span\'> {N} </span> TIME',
  'ramadan.new.honor.toTop1.times': 'UP NEED <span class=\'span\'> {N} </span> TIMES',
  'ramadan.new.honor.my.times': 'My Times',
  'ramadan.new.event.start': 'Event is about to start',
  'ramadan.new.my.tickets': 'My Tickets',
  'ramadan.new.estimated.win': 'Estimated win',
  'ramadan.new.prize.content': 'You have received',
  'ramadan.new.collect': 'Collect',
  'ramadan.new.tab1': 'Ramadan Sign-In',
  'ramadan.new.sign.day': 'Sign-In for {N} days',
  'ramadan.new.collected': 'Collected',
  'ramadan.new.today.content': 'Sign-In today can get:',
  'ramadan.new.ok': 'OK',
  'ramadan.new.bottom.desc': 'Recharge once a day and you can re-sign once',
  'ramadan.new.resign.btn': 'Re-Sign In',
  'ramadan.new.resign.content': 'Successful re-signing gets:',
  'ramadan.new.resign.fail.content': 'Recharge once a day and you can re-sign once.（Coins purchased from resellers will be counted; purchases from the platform by resellers will not be counted.）',
  'ramadan.new.resign.fail.btn': 'Recharge Now',
  'ramadan.new.tab2': 'Prayer Ranking',
  'ramadan.new.tab3': 'Blessing Honor',
  'ramadan.new.next': 'NEXT',
  'ramadan.new.back': 'Back',
  'ramadan.new.not.remain': 'Don\'t show it again.',
  'ramadan.new.had.sign': 'You\'ve re-signed in today.',
  'ramadan.new.nickname': 'Nickname',
  'lasser.bairam.collect': 'Collect',
  'lasser.bairam.ok': 'OK',
  'lasser.bairam.waiting': 'waiting',
  'lasser.bairam.special.gift.title': 'Bonus box',
  'lasser.bairam.special.gift.to.be.drawn': 'To be drawn',
  'lasser.bairam.special.gift.to.complete': 'Complete now',
  'lasser.bairam.special.gift.contribution': 'Contribution chest',
  'lasser.bairam.special.gift.lucky': 'Lucky eid chest',
  'lasser.bairam.special.gift.desc': 'Accumulated limited gift value received {d} diamonds can participate in the selection of lucky stars ({z}/{m})',
  'lasser.bairam.tab.scene': 'Eid al-Fitr trip',
  'lasser.bairam.tab.ranking': 'Ranking',
  'lasser.bairam.scene.tips': 'Give out limited gifts across the server and reach the corresponding number of gold coins to unlock scenes and get rewards. MVPs have additional rewards.',
  'lasser.bairam.scene.rewards.desc': 'After participating in unlocking the current scene, you can get the following rewards, and MVP has additional rewards.',
  'lasser.bairam.scene.unlock.modal.title': 'Congratulations on your participation in unlocking the location:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Can get',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'MVP can get',
  'lasser.bairam.rewards.tips': 'This page displays the total ranking rewards. For details on gold coin rewards, please refer to the rules page.',
  'lasser.bairam.go.look': 'Check it now!',
  'lasser.bairam.no.time.yet': 'Not time yet',
  'lasser.bairam.next.round': 'Next round',
  'lasser.bairam.ranking.tab.send': 'Wealth Ranking',
  'lasser.bairam.ranking.tab.receive': 'Charm Ranking',
  'common.cap.Success': 'Success',
  'family.football.no.tips': 'No more tips for next time',
  'common.cap.Record': 'Record',
  'coins.battle.time': 'time',
  'coins.battle.times': 'times',
  'coins.battle.draw.total.coins': 'Accumulated:<span class=\'num\'>{totalRechargeCoins}</span>Coins',
  'coins.battle.draw.remain.times': 'Remaining times: {remainTime} times',
  'coins.battle.draw.no.recharge': 'Only need to recharge {coinToDrawCount} coins for the first time.',
  'coins.battle.draw.recharged': 'Accumulated recharge of {coinToDrawCount} coins: Draw times +1',
  'coins.battle.draw.drawing.tips': 'Drawing Tips',
  'coins.battle.draw.drawing.tips.desc': 'Insufficient Draw times! Recharge to get more times now!',
  'coins.battle.draw.drawing.tips.recharge.now': 'Recharge Now',
  'coins.battle.task.title': 'Task display area',
  'coins.battle.task.go': 'Go',
  'coins.battle.task.completed': 'Completed',
  'coins.battle.task.tips': 'Every task you complete wins a draw.',
  'coins.battle.entry.title': 'Surprise Benefits',
  'coins.battle.entry.desc': 'You have one chance to draw coins up to 1million!',
  'coins.battle.entry.btn': 'Recharge {coinToDrawCount} coins to get',
  'coins.battle.rules.not.show.again': 'Don\'t show it again.',
  'coins.battle.result.title': 'Congratulations!',
  'coins.battle.result.prize.pool': 'Get {N}% coins of the prize pool',
  'coins.battle.result.get': 'Get',
  'coins.battle.record.tab.draw.record': 'Draw Record',
  'coins.battle.record.tab.number.of.draws': 'Number of draws',
  'coins.battle.record.head.time': 'Time',
  'coins.battle.record.head.coins.or.tasks': 'Coins/Tasks',
  'coins.battle.record.complete.task': 'Complete Task {N}',
  'common.cap.Coins': 'Coins',
  'common.cap.time': 'time',
  'common.cap.times': 'times',
  'common.cap.my.times': 'my times',
  'common.cap.Sure': 'Sure',
  'common.cap.not.remind': 'no more reminders',
  'lucky.draw.may.tab.draw': 'Mecha draw',
  'lucky.draw.may.tab.vote': 'Mecha Star',
  'lucky.draw.may.tab.ranking': 'ranking',
  'lucky.draw.may.draw.draw.times': 'draw*{%d}',
  'lucky.draw.may.draw.draw.tips': 'sending limited gifts for {%d}coins can get a chance to draw',
  'lucky.draw.may.confirm.text': 'Are sure to expend {%s} x{%d} to draw?',
  'lucky.draw.may.vote': 'vote',
  'lucky.draw.may.vote.top3.title': 'top3 rewards',
  'lucky.draw.may.vote.top3.tips': 'more rewards details please find in rules page',
  'lucky.draw.may.vote.please.enter.id': 'Please enter id',
  'lucky.draw.may.vote.tips': 'sending limited gifts for {%d} coins can get 1 tickets',
  'lucky.draw.may.vote.search.tips': 'Only anchors can be voted on',
  'lucky.draw.may.vote.cur.ranking': 'current ranking：{%d}',
  'lucky.draw.may.vote.voting.record': 'Voting record',
  'lucky.draw.may.vote.voting.record.user': 'user',
  'lucky.draw.may.vote.voting.record.number': 'number of votes',
  'lucky.draw.may.rewards.tips': 'For detailed rules on how to get the rewards, please go to the rules page',
  'lucky.draw.may.unlock': 'Unlock',
  'lucky.draw.may.unlock.some': 'congratulation to unlock {%s}%,Take these rewards～',
  'lucky.draw.may.unlock.all': 'Thank you for unlocking all puzzle,take all rewards',
  'lucky.draw.may.result.tips': '{%s} will be used to unlock the puzzle',
  'common.cap.confirm': 'Confirm',
  'common.cap.cancel': 'Cancel',
  'common.cap.month1': 'Jan',
  'common.cap.month2': 'Feb',
  'common.cap.month3': 'Mar',
  'common.cap.month4': 'Apr',
  'common.cap.month5': 'May',
  'common.cap.month6': 'Jun',
  'common.cap.month7': 'Jul',
  'common.cap.month8': 'Aug',
  'common.cap.month9': 'Sept',
  'common.cap.month10': 'Oct',
  'common.cap.month11': 'Nov',
  'common.cap.month12': 'Dec',
  'fes.of.sa.not.start': 'Event is about to start',
  'fes.of.sa.tab1': 'Roast Lamb Challenge',
  'fes.of.sa.tab2': 'Crazy Lambfold',
  'fes.of.sa.free': 'FREE!',
  'fes.of.sa.collect.tools': 'Collect tools to Roast Lamb',
  'fes.of.sa.combine': 'Combine',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.ranking': 'Ranking',
  'fes.of.sa.tip.text': 'You have more than {N} lamb to combine, combine now?',
  'fes.of.sa.ok': 'OK',
  'fes.of.sa.records': 'Record',
  'fes.of.sa.draw': 'draw*{%d}',
  'fes.of.sa.ticket.enough': 'Insufficient tickets, send gifts to get more',
  'fes.of.sa.draw.again': 'Draw again',
  'fes.of.sa.time': 'Time',
  'fes.of.sa.recharge.btn': 'Recharge',
  'fes.of.sa.send.btn': 'Send',
  'fes.of.sa.rank.tab1': 'Roast Lamb Ranking',
  'fes.of.sa.rank.tab2': 'Charm Ranking',
  'fes.of.sa.rank.daily': 'Daily',
  'fes.of.sa.rank.total': 'Total',
  'fes.of.sa.lamb.top': 'Catch lambs for free, get 5 times of ranking points!',
  'fes.of.sa.unlock.btn': 'SEND GIFT TO UNBLOCK',
  'fes.of.sa.wait.lock': 'TO BE OPEN!',
  'fes.of.sa.catch.btn': 'CATCH ({N})',
  'fes.of.sa.lamb.rewards': 'FREE GIFT FROM LAMBFOLD',
  'fes.of.sa.catch.suc.title': 'Successfully Catch!',
  'fes.of.sa.catch.suc.text': 'Congratulations! You got 1 free lamb!\nFree lambs from lambfold will counts 5 times points on Lamb Ranking!',
  'fes.of.sa.catch.cong.title': 'Congratulations!',
  'fes.of.sa.catch.cong.text': 'Falid to catch lamb this time, we send you a best wish and another gift!',
  'fes.of.sa.catch.oops': 'Oops..',
  'fes.of.sa.catch.oops.text': 'Falid to get rewards this time, TalkTalk send you a best wish! Try again!',
  'fes.of.sa.event.gift': 'Event Gift',
  'game.king.prize.pool': 'Prize Pool',
  'game.king.tab1': 'Throne Controversy',
  'game.king.tab2': 'Brave Dragon lsland',
  'game.king.game.king': 'GAME KING',
  'game.king.bounds.gold': 'Bonus Gold',
  'game.king.score': 'SCORE',
  'game.king.king.desc': 'Points for this round',
  'game.king.king.reward': 'King\'s Reward',
  'game.king.you.is.king': 'YOU ARE THE KING OF GAMES',
  'game.king.will.start': 'ABOUT TO START',
  'game.king.brave.dragon.island': 'BRAVE DRAGON ISLAND',
  'game.king.cur.strogest': 'Current Strongest',
  'game.king.attack': 'Attack',
  'game.king.unused.battle': 'Unused Battle Points',
  'game.king.current.battle': 'Current battle value',
  'game.king.strongest.warrior': 'Strongest Warrior',
  'game.king.lucky.warrior': 'Lucky Warrior',
  'game.king.last.warrior': 'Last Strike Warriors',
  'game.king.warrior.ranking': 'Warrior Ranking',
  'game.king.spend.attack': 'Whether to spend {N} combat power to attack',
  'game.king.not.reminder': 'No more reminders',
  'game.king.reminder': 'Reminder',
  'game.king.go.center': 'Dear，your combat power is insufficient. Please participate in the game to obtain combat power',
  'game.king.get.rewards': 'Get Rewards',
  'game.king.other.king.rewards': 'Congratulations to {nickname} for being the {Awardname} and getting {receiveCoin} gold!',
  'game.king.reward.name': 'Reward Name',
  'game.king.reward': 'Rewards',
  'game.king.award.time': 'Award Time',
  'game.king.warrior.rewards': 'Warrior Rewards',
  'game.king.self.king.rewards': 'Congratulations on being the {Awardname} and receiving: {receiveCoin} gold coins',
  'game.king.warrior.dialog.text': 'Congratulations on becoming {Awardname} on {time} and earning: {receiveCoin} gold coins!',
  'game.king.king.model.coin': 'Battle for the Throne: Getting Gold Coins {receiveCoin}',
  'game.king.king.model.times': 'Number of times you\'ve been king of the game today: {amount}',
  'game.king.divide.pool': 'Divide gold coin pool*{receiveCoin}',
  'game.king.cog': 'Congratulations!',
  'game.king.end.desc': 'Dear brave warrior\nCongratulations on your #{rankings} achievement in the Warrior Rankings, and receive the following rewards',
  'game.king.yes': 'YES',
  'game.king.no': 'NO',
  'game.king.become.self': 'Congratulations on becoming {Awardname}',
  'game.king.become.nick': 'Congratulations on {nickname} becoming {Awardname}',
  'game.list.play.now': 'Go play games',
  'game.list.rewards.coin.reward.title': 'Gold coin rewards',
  'game.list.rewards.coin.reward.tag': 'Reaching threshold value',
  'game.list.rewards.prop.reward.title': 'Prop rewards',
  'jungle.e.not.start': 'Event is about to start',
  'jungle.e.tab1': 'Roast Lamb Challenge',
  'jungle.e.tab2': 'Ranking',
  'jungle.e.tab3': 'Crazy Lambfold',
  'jungle.e.tool.title': 'Collect tools to Roast Lamb',
  'jungle.e.combine': 'Combine',
  'jungle.e.times': 'Times X{N}',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.tip.desc': 'You have more than {N} chest to synthetic, synthetic now?',
  'jungle.e.ok': 'OK',
  'jungle.e.collect.title': 'Flame Collection',
  'jungle.e.collect.desc': 'Daily collect Flame to get special gift&earn {N} times of Charm Ranking points!',
  'jungle.e.day.refresh': 'Daily refresh at',
  'jungle.e.record': 'Record',
  'jungle.e.draw.time': 'draw*{%d}',
  'jungle.e.ticket.enough': 'Insufficient Adventure Card, complete tasks to get more',
  'jungle.e.win.desc': 'Congratulations on winning following awards',
  'jungle.e.draw.again': 'Draw again',
  'jungle.e.time': 'Time',
  'jungle.e.rechrge': 'Recharge',
  'jungle.e.send': 'Send',
  'jungle.e.sec.tab1': 'Roast Lamb Ranking',
  'jungle.e.sec.tab2': 'Charm Ranking',
  'jungle.e.daily': 'Daily',
  'jungle.e.Total': 'Total',
  'jungle.e.self.last': '{N} from the previous one',
  'jungle.e.target': 'Threshold: {N}',
  'jungle.e.coin.reach': 'All members’ Gifting reach {N} to unlock Super Coins Chest',
  'jungle.e.coin.finish': 'Synthetic more Treasure Chest, get more coins from Super Coins Chest!',
  'jungle.e.coin.reach.anchor': 'Unblock the Super Diamond Chest when the total number of gifts received reaches {N}',
  'jungle.e.coin.finish.anchor': 'Receive more event gifts and share more diamonds!',
  'jungle.e.wating.unlocked': 'Amount of prize pool to be unlocked',
  'jungle.e.pool.amount': 'Total Prize Pool Amount',
  'jungle.e.divied.coin': 'Currently can share: {N} coins',
  'jungle.e.divied.coin.anchor': 'Currently you can share {N} diamonds',
  'jungle.e.send.lock': 'Send {N} more coins to unlock',
  'jungle.e.send.lock.anchor': 'Receive {N} more gifts to unlock',
  'jungle.e.btn.finish': 'Send more event gift, share more coins>>',
  'jungle.e.btn.finish.anchor': 'Receive more active gifts and share more diamonds!',
  'jungle.e.coin.rewards': 'Crazy Lambfold Rewards',
  'jungle.e.winner.list': 'Winner List',
  'jungle.e.win': 'WIN',
  'jungle.e.event.gift': 'Event Gift',
  'jungle.e.cong.title': 'Congratulations!',
  'crazy.bulider.ranking': 'Ranking',
  'crazy.bulider.daily.top1': 'Daily TOP1',
  'crazy.bulider.floors.n': 'Floors{N}',
  'crazy.bulider.build.n': 'Build {N} Time',
  'crazy.bulider.build.all': 'Build All',
  'crazy.bulider.luck.gift.desc': 'Send lucky gift every {N} coins = 1{hammerIcon}',
  'crazy.bulider.rewards.tab1': 'Floor Rewards',
  'crazy.bulider.rewards.tab2': 'Ranking Rewards',
  'crazy.bulider.daily': 'Daily Ranking',
  'crazy.bulider.total': 'Total Ranking',
  'crazy.bulider.congura': 'Congratulations!',
  'crazy.bulider.model.rewards.desc': 'You have been awarded',
  'crazy.bulider.ok': 'OK',
  'crazy.bulider.opps': 'Opps!',
  'crazy.bulider.time.not.desc': 'Insufficient build times!<br/>The grand prize is waiting for you!',
  'crazy.bulider.get.more': 'GET MORE',
  'crazy.bulider.celebrate.desc': 'Congras on building {N} floors!',
  'crazy.bulider.lucky.moment': '⭐️Lucky Moment⭐️',
  'crazy.bulider.lucky.desc': 'Choose 1 Lucky Box to get bonus!',
  'crazy.bulider.click.celebrate': 'Click To Celebrate',
  'crazy.bulider.waiting': 'Waiting',
  'crazy.bulider.status.start': 'Event is about to start',
  'crazy.bulider.status.end': 'The event is over',
  'crazy.bulider.status.count': 'Countdown',
  'crazy.bulider.share.moment': 'Share To Moment',
  'crazy.bulider.share': 'Share',
  'crazy.bulider.share.ok': 'OK',
  'crazy.bulider.share.desc1': 'You already surpassed 90% of the constructors! Quickly share the current view with your friends!',
  'crazy.bulider.share.desc2': '*First time successful sharing to Moment can get exclusive rewards for super constructors ↓.,',
  'crazy.bulider.share.desc3': '{X} people also start constructing buildings by seeing your moment!',
  'crazy.bulider.share.desc4': 'Thank you for your influence!',
  'crazy.bulider.share.desc5': 'The skyscrapers are under my control!',
  'crazy.bulider.share.reward': 'You have been rewarded',
  'crazy.bulider.progress.current': 'Current:{M}={N}',
  'crazy.bulider.progress.target': 'Target:',
  'crazy.bulider.share.text': '#👷Crazy Constructor🚧#\nSuper Power Affects the World! 🌏\n{N} Floors built with passion🔥\nGlobal Ranking: #{Rank} 👑\nNice chance to build own skyscraper!🏙',
  'crazy.bulider.share.success': 'Shared Success!',
  'speed.passion.race': 'A race',
  'speed.passion.ranking': 'Ranking',
  'speed.passion.change': 'change',
  'speed.passion.Completed': 'Completed',
  'speed.passion.daily.task': 'daily task',
  'speed.passion.go.for.it': 'Go for it',
  'speed.passion.Done': 'Done',
  'speed.passion.winning.TOP1': 'Winning Top1',
  'speed.passion.Daily.Rewards': 'Daily Rewards',
  'speed.passion.naming.unnamed': 'unnamed',
  'speed.passion.naming.desc': 'The user who sends this gift the most during the event will named this gift the following week!',
  'speed.passion.naming.progress': 'Named Progress',
  'speed.passion.naming.progress.get.the.number': 'Get the number',
  'speed.passion.naming.progress.no.one.get': 'No one has access to it yet, so get involved!',
  'speed.passion.limited.desc': 'Named users earn {N}x miles on sending their Named gift',
  'speed.passion.change.change.group': 'Change the group',
  'speed.passion.change.change.desc': 'Sure you want to change to this group?',
  'speed.passion.change.change.ps': 'PS: All the rewards of this group will be unavailable after changing group.',
  'speed.passion.Result': 'Result',
  'speed.passion.Result.win': 'Congrats to yesterday {N} for coming in first, take these rewards!',
  'speed.passion.Result.lose': 'No team won yesterday, so let\'s try again today.',
  'speed.passion.Result.ps': 'PS: Only the MVP of the winning group will get extra rewards!',
  'speed.passion.choice.group': 'Select group',
  'speed.passion.choice.group.desc': 'Gained after joining the group',
  'speed.passion.rank.daily': 'daily',
  'speed.passion.rank.total': 'total',
  'speed.passion.rank.not.time': 'It\'s not time yet.',
  'speed.passion.rank.Mileage': 'Mileage:',
  'speed.passion.rank.no.rank': 'My group',
  'family.battle.new.up.need.s': 'Up Need {N}',
  'hungry.ghost.collect': 'Collect',
  'hungry.ghost.ok': 'OK',
  'hungry.ghost.waiting': 'waiting',
  'hungry.ghost.special.gift.title': 'Bonus box',
  'hungry.ghost.special.gift.to.be.drawn': 'To be drawn',
  'hungry.ghost.special.gift.to.complete': 'Complete now',
  'hungry.ghost.special.gift.contribution': 'Contribution chest',
  'hungry.ghost.special.gift.lucky': 'Lucky Chest',
  'hungry.ghost.special.gift.desc': 'Accumulated limited gift value received {%d} coins can participate in the selection of lucky stars ({%z}/{%m})',
  'hungry.ghost.tab.scene': 'Halloween Adventure',
  'hungry.ghost.tab.ranking': 'Ranking',
  'hungry.ghost.scene.tips': 'Give out limited gifts across the server and reach the corresponding number of coins to unlock scenes and get rewards. MVPs have additional rewards.',
  'hungry.ghost.scene.rewards.desc': 'After participating in unlocking the current scene, you can get the following rewards, and MVP has additional rewards.',
  'hungry.ghost.scene.unlock.modal.title': 'Congratulations on your participation in unlocking the location:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Can get',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'MVP can get',
  'hungry.ghost.rewards.tips': 'For details on getting Coins and Diamonds, please check the rules page.',
  'hungry.ghost.go.look': 'Check it now!',
  'hungry.ghost.no.time.yet': 'Not time yet',
  'hungry.ghost.next.round': 'Next round',
  'hungry.ghost.ranking.tab.send': 'Wealth Ranking',
  'hungry.ghost.ranking.tab.receive': 'Charm Ranking',
  'fishing.activity.bomber': 'Bomber',
  'fishing.activity.fishnet': 'Fishnet',
  'fishing.activity.energy.not': 'Energy value is insufficient!',
  'fishing.activity.get.more': 'GET MORE',
  'fishing.activity.congrats': 'Congrats!',
  'fishing.activity.ok': 'OK',
  'fishing.activity.catches.more': 'There are new catches!',
  'fishing.activity.put.aquarium': 'Put into Aquarium',
  'fishing.activity.catche.single': 'There\'s a new catch!',
  'fishing.activity.new': 'NEW',
  'fishing.activity.slipped.away': 'The fish slipped away!',
  'fishing.activity.try.again': 'TRY AGAIN',
  'fishing.activity.step1': 'Welcome! Click on the fishing rod to fish for free!',
  'fishing.activity.step3': 'Getting a new type of fish can be lighted in aquarium, and collecting all fish can get rich coins rewards!',
  'fishing.activity.step5': 'Fish again!',
  'fishing.activity.fishing.big': 'Lucky! Meet Big Fish! Click the rod to increase the pulling force and reach the target value to catch the big fish!',
  'fishing.activity.step8': 'Congrats to get a free Bomber! Try the power of Bomber now!',
  'fishing.activity.step10': 'Catch duplicate types of fish will be exchanged automatically for Coupons, which can be used to buy items in the Store!',
  'fishing.activity.step12': 'Come back tomorrow can get 1 more free Bomber!',
  'fishing.activity.start.fishing': 'Start to fishing',
  'fishing.activity.cap.Records': 'Records',
  'fishing.activity.cap.Unfinished': 'Unfinished',
  'fishing.activity.cap.Date': 'Date',
  'fishing.activity.cap.no.record.yet': 'No record yet.',
  'fishing.activity.store': 'STORE',
  'fishing.activity.gallery': 'AQUARIUM',
  'fishing.activity.rank': 'MASTER',
  'fishing.activity.energy': 'ENERGY',
  'fishing.activity.achievement': 'ACHIEVEMENT',
  'fishing.activity.records.fish': 'Fish',
  'fishing.activity.records.coupon': 'Coupon',
  'fishing.activity.records.others': 'Others',
  'fishing.activity.store.limit': 'Limit:',
  'fishing.activity.store.buy': 'Buy',
  'fishing.activity.store.sold.out': 'SOLD OUT',
  'fishing.activity.gallery.tips': 'Collect all kinds of fish to receive generous coins!',
  'fishing.activity.rank.tips': 'Daily TOP 5 Fishing Stars get extra rewards!',
  'fishing.activity.energy.tips': 'Daily tasks update at 00:00,remember to collect rewards on time!',
  'fishing.activity.fish.ticket.not': 'Coupon is insufficient!',
  'fishing.activity.you.got': 'You have been awarded:',
  'fishing.activity.go': 'Go',
  'fishing.activity.not.time': 'This stage is about to start',
  'anniversary.celebration.2.collect': 'Collect',
  'anniversary.celebration.2.ok': 'OK',
  'anniversary.celebration.2.waiting': 'waiting',
  'anniversary.celebration.2.special.gift.title': 'Bonus box',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'To be drawn',
  'anniversary.celebration.2.special.gift.to.complete': 'Complete now',
  'anniversary.celebration.2.special.gift.contribution': 'Charming Chest',
  'anniversary.celebration.2.special.gift.lucky': 'Lucky Chest',
  'anniversary.celebration.2.special.gift.desc': 'Accumulated limited gift value received {%d} coins can participate in the selection of lucky stars ({%z}/{%m})',
  'anniversary.celebration.2.tab.scene': 'Celebration Journey',
  'anniversary.celebration.2.tab.ranking': 'Ranking',
  'anniversary.celebration.2.scene.tips': 'All platforms coins consumption(except game part&send lucky package) reaches target value to unlock scenes to get rewards. Send limited gifts can get doulbe points!',
  'anniversary.celebration.2.scene.rewards.desc': 'After participating in unlocking the current scene, you can get the following rewards, and MVP has additional rewards.',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Congratulations on your participation in unlocking the location:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Can get',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'MVP can get',
  'anniversary.celebration.2.rewards.tips': 'For details on getting Coins and Diamonds, please check the rules page.',
  'anniversary.celebration.2.go.look': 'Check it now!',
  'anniversary.celebration.2.no.time.yet': 'Not time yet',
  'anniversary.celebration.2.next.round': 'Next round',
  'anniversary.celebration.2.ranking.tab.send': 'Wealth Ranking',
  'anniversary.celebration.2.ranking.tab.receive': 'Charm Ranking',
  'crazybuilder.king.record': 'All-time high Record',
  'crazybuilder.mine.record': 'My Current Record',
  'crazybuilder.reaching.floors': 'Cannot be shared till reaching the target floors',
  'crazybuilder.friends.list': 'Friends List',
  'crazybuilder.friends.list.text': 'Everyday visits will add ❤️ to your friend\'s town.',
  'crazybuilder.friends.list.visit': 'Visit',
  'crazybuilder.map.share.desc': 'Share your Prosperity Town! Invite your friends to celebrate together!',
  'crazybuilder.map.share.btn': 'Share Now',
  'crazybuilder.map.notify.title': 'Congratulations!',
  'crazybuilder.map.notify.desc': 'Your town gets favorites!Keep building to attract more visitors!',
  'crazybuilder.map.notify.btn': 'OK',
  'crazybuilder.map.enter': 'Town',
  'crazybuilder.toast.reach': 'Reach {n} floors can share your Building Achievement! And can get the following rewards:',
  'crazybuilder.map.share.text': '#👷Crazy Constructor🚧#\nSupreme Ability required to build Prosperity Towns! 👑💪\n{N} Floors are engraved with my name-{Nickname}.🌃\n{M} favorites❤️ awarded to my Prosperity Town⭐️\nWelcome to my town to see our gap😎',
  'gamecenter_ranking_txt6': 'Lucky Ranking',
  'gamecenter_ranking_txt7': 'Win more than 5000 coins in the game to qualify for the leaderboard, with the most recent qualifying users ranking higher.',
  'iosso_wallet_txt1': 'More',
  'iosso_wallet_txt2': 'Fold',
  'chat_skill_title': 'Must-Read for Anchors',
  'new.ranking.list.charm': 'Charm',
  'new.ranking.list.contribution': 'Contribution',
  'new.ranking.list.record': 'Record',
  'game.list.plus.empyt.list': 'No data',
  'withdraw_text_0': 'Income',
  'withdraw_text_1': 'Balance',
  'withdraw_text_2': 'Withdraw',
  'withdraw_text_3': 'Exchange',
  'withdraw_text_4': 'Withdrawals record',
  'withdraw_text_5': 'Insufficient diamond balance',
  'withdraw_text_6': 'Get more diamonds',
  'withdraw_text_7': 'Order number:',
  'withdraw_text_8': 'Channel:',
  'withdraw_text_9': 'Amount:',
  'withdraw_text_10': 'Diamond:',
  'withdraw_text_11': 'Schedule:',
  'withdraw_text_12': 'Under review',
  'withdraw_text_13': 'Withdraw successfully',
  'withdraw_text_14': 'Withdrawal failed',
  'withdraw_text_15': 'Reason for failure',
  'share_text100': 'Copied',
  'withdraw_text_16': 'Only show records from the last 3 months',
  'withdraw_text_21': 'Withdrawal Amount',
  'withdraw_text_22': 'Deducted diamonds',
  'withdraw_text_23': 'Payment method:',
  'withdraw_text_24': 'Add payment method',
  'withdraw_text_25': 'Withdraw immediately',
  'withdraw_text_27': 'Feedback question',
  'withdraw_text_28': 'Contact Customer Service',
  'withdraw_text_30': '1. Withdrawal is allowed at most once per day',
  'withdraw_text_31': '2. You must complete the real person authentication and binding the payment method before you can initiate a withdrawal.',
  'withdraw_text_32': '3. The platform does not charge any fees. The service fee is deducted by the channel. The service fees are different for different channels. Please contact the channel customer service for details.',
  'withdraw_text_33': '4. Withdrawal progress can be viewed through ‘Withdrawal Record’',
  'withdraw_text_34': '5. If the withdrawal fails, the diamonds will be returned',
  'withdraw_text_35': '6. Withdrawal applications will be processed within 7-14 working days (extension on holidays)',
  'withdraw_text_36': 'Must be completed',
  'withdraw_text_37': '1. Real person authentication',
  'withdraw_text_38': '2. Add payment method',
  'program_faq_13_ios': 'Tips',
  'exchange_text_1': 'Exchange',
  'exchange_text_2': 'Coins Balance',
  'exchange_text_3': 'Diamonds Balance',
  'exchange_text_4': 'Custom Exchange',
  'exchange_text_5': 'Exchange Rules',
  'exchange_text_6': 'Exchange Rate',
  'exchange_text_7': 'Daily Exchange Limit',
  'exchange_text_8': 'Confirm the exchange?',
  'exchange_text_9': 'Spent:',
  'exchange_text_10': 'Get:',
  'exchange_text_13': 'Insufficient Diamond Balance',
  'withdraw_text_42': 'No supported payment method',
  'withdraw_text_39': 'Bind',
  'withdraw_text_40': 'Check',
  'exchange_text_18': 'Exceeded the exchange limit.',
  'exchange_text_14': 'Exchange successful',
  'ios_rechargeguide_txt3': 'Coins Back',
  'ios_rechargeguide_txt4': 'Claim',
  'aristocracy.vip.coin.box.sub.title': 'Valid till',
  'program_faq_2': 'Program Schedule Introduction',
  'program_faq_3': 'To enhance fun and interactivity, we provide a program schedule feature. The program schedule serves as a preview of the room\'s upcoming programs. Viewers can vote and send gifts based on the program schedule, expressing their preferences and enthusiasm for the room\'s programs.',
  'program_faq_4': 'Program Schedule Entrance',
  'program_faq_5': 'The room owner or administrator can access the program schedule through the Settings menu. Viewers can enter the program schedule by clicking on the top right corner of the room when the program is live.',
  'program_faq_6': 'How to Set Up a Program Schedule',
  'program_faq_7': 'Click on \"Add Program\" and enter the name of the program you want to perform.',
  'program_faq_8': 'After creating and reviewing the program schedule, click on \"Start Program Schedule\" to make it visible to the audience. Once enabled, viewers will be able to see the program schedule.',
  'program_faq_9': 'How to Interact with the Program Schedule',
  'program_faq_10': 'Everyone in the room can access the program schedule by clicking on the top right corner and show support for their favorite programs by clicking on \'Interested\' or \'Send Gift\' to increase the program\'s popularity.',
  'program_faq_11': 'Delete a program or close the program schedule.',
  'program_faq_12': 'The room owner or administrator can swipe left on a program and click on \"Delete\" to remove the program. The program schedule will automatically close after 7 days, but the host or administrator can also manually close it. Deleting a program or closing the program schedule will clear the program popularity data.',
  'program_faq_13': 'Tips',
  'program_faq_14': '1. The program schedule allows a maximum of 15 programs to be added.',
  'program_faq_15': '2. A program schedule that has failed the review cannot be opened.',
  'program_faq_16': '3. The program schedule will automatically close after 7 days of being opened.',
  'program_faq_part1': 'PART1',
  'program_faq_part2': 'PART2',
  'program_faq_part3': 'PART3',
  'program_faq_part4': 'PART4',
  'withdraw_text_45': 'Submission time',
  'withdraw_text_46': 'It will arrive in your account within 5 working days. The specific progress can be checked in the withdrawal record.',
  'withdraw_text_47': 'Complete',
  'withdraw_text_48': 'Payment method',
  'payment_bind_1': 'Account',
  'exchange_text_16': 'Exchange failed.',
  'withdraw_text_59': 'Update',
  'terms.help': 'App Problems',
  'terms.bug': 'Bug',
  'terms.suggestions': 'Suggestions',
  'contacts.whatsapp': 'Whatsapp',
  'contacts.email': 'Email',
  'contacts.phone': 'Phone',
  'submit.success': 'Thanks for your feedback',
  'terms.title': 'Category',
  'details.placeholder': 'Please describe the details of your problem',
  'contacts.title': 'How to contact you',
  'contact.placeholder': 'Leave your contact information here[Confidential]',
  'submit.btn': 'Submit',
  'country.select.hot': 'Hot',
  'country.select.all': 'All',
  'feedback.details': 'Details',
  'feedback.screenshot': 'Screenshot (Optional)',
  'feedback.title': 'Feedback',
  'subTitle': 'Do Not Trust Other Recharge Channels Other Than Verified Merchants.',
  'chat': 'Chat',
  'id': 'SOYO ID',
  'contact': 'Contact',
  'whatsapp': 'WhatsApp',
  'right': 'SOYO team reserves the right of final interpretation.',
  'check': 'Password must consist of 8 digits and uppercase and lowercase letters',
  'same': 'Please enter the same password',
  'copied': 'copied',
  'order.record.title': 'Record',
  'order.record.failed': 'Recharge Failed',
  'order.record.recharging': 'Recharging',
  'order.record.succeeded': 'Recharge Succeeded',
  'order.record.order.id': 'Order id: {id}',
  'order.record.channel': 'Channel: {name}',
  'about.title': 'About',
  'Return Policy': 'Return Policy',
  'Intellectual Property Rights': 'Intellectual Property Rights',
  'Contact Us': 'Contact Us',
  'About Us': 'About Us',
  'Supported Payment Methods': 'Supported Payment Methods',
  'retirar.rules.title': 'Withdrawal Rules',
  'retirar.rules.rules.1': '1.Before using the withdrawal service, you need to submit real identity information to ensure the safety of your account',
  'retirar.rules.rules.2': '2. Please provide real identity information, which will be used as the basis for identification and determination of the right to use your account',
  'retirar.rules.rules.3': '3. The identity information you submit will be kept strictly confidential and will not be used for other purposes',
  'retirar.rules.chat': 'Contact Customer Service',
  'retirar.rules.important': 'Emphasis:',
  'retirar.rules.rules.extra': 'Please contact customer service with the need to use the withdrawal service and provide the following information:',
  'retirar.rules.rules.extra.1': '1) Real name',
  'retirar.rules.rules.extra.2': '2) Whatsapp number',
  'retirar.rules.rules.extra.3': '3) Identity documents (identity cards, passports, etc.)',
  'retirar.rules.rules.extra.4': '4) Your payment method (BankTransfer, Payoneer, Fawry, etc.)',
  'income.rules.rules.1': '1. Salary Rules: the 16th of each month and the first of the following month 00:00 will be deducted from the account diamond balance',
  'income.rules.rules.2': '2. Salary Ratio: 1USD=0diamonds',
  'income.rules.rules.3': '3.Settlement Time: ①the 16th of each month 00:00② the first of the following month 00:00',
  'income.rules.rules.4': '4.Settlement Period: 7~14 working days(holidays are postponed)',
  'income.rules.chat': 'Contact Customer Service',
  'income.rules.important': 'Emphasis:',
  'income.rules.title': 'Salary Rules',
  'income.rules.rules.extra': 'We will notify you via \"Team\" when the salary is settled. The details of diamond deduction can be checked in \"Income\", please pay attention to Team notifications. Normal settlement will be completed within 7-14 business days, if there is a holiday, the bank release period will be delayed, please be patient and wait for the payment. If you have any questions, please contact Customer Service, thank you for your support!',
  'income.rules.usd': 'USD',
  'income.rules.diamonds': 'Diamonds',
  'home.recharge': 'Recharge',
  'home.slogan': 'Meet your soulmate Here<br />Always with you',
  'home.download': 'Download',
  'recharge.result.success': 'Payment Success',
  'recharge.result.error': 'Payment Failed',
  'recharge.result.jumping_to_app': 'Jumping to App...',
  'recharge.result.app_not_installed': 'App not installed',
  'recharge.result.download_app_tip': 'Please download and install the app to continue',
  'report.option.Porn': 'Pornography',
  'report.option.Spam': 'Spam',
  'report.option.Fraud': 'Fraud',
  'report.option.Violence': 'Violence',
  'report.option.Illegal': 'Illegal',
  'report.option.Other': 'Other',
  'report.option.room': 'I don\'t like this',
  'report.option.user': 'I don\'t like the user',
  'report.reason': 'Category',
  'report.details': 'Details',
  'report.details.placeholder': 'Describe the details of your report',
  'report.screenshot': 'Screenshot (Optional)',
  'report.submit': 'Submit',
  'report.submit.success': 'Reported Successfully',
  'report.room': 'Report',
  'report.user': 'Report User',
  'payment_bind_28': 'Account Type',
  'payment_bind_29': 'PAYPAL_ID',
  'payment_bind_30': 'Account Number',
  'payment_bind_32': 'Phone number',
  'payment_bind_33': 'Must be 12 digits starting with 2541 or 2547',
  'payment_bind_34': 'Choose Bank',
  'payment_bind_35': 'Search Bank',
  'payment_bind_36': 'Account name',
  'payment_bind_37': 'Must be numbers only, no spaces or special characters',
  'payment_bind_38': 'Must be 9 or 10 digits and cannot start with 233',
  'payment_bind_39': 'Must be a valid email with @ and a suffix of at least 2 characters, no spaces',
  'payment_bind_40': 'Must be 10 digits, numbers only, no spaces or special characters',
  'payment_bind_41': "Only English letters, numbers, spaces and apostrophes ('), must start with a letter",
  'family_text_116': 'Recommend',
  'family_text_117': 'Ranking',
  'family_text_97': 'Today',
  'family_text_98': 'Monthly',
  'family_text_108': 'Yesterday',
  'family_text_69': 'Last month',
  'family_text_95': 'Popular',
  'family_text_96': 'New',
  'family_text_68': 'This month',
  'family_toast_03': 'Join',
  'family_toast_04': 'Under review',
  'family_toast_05': 'Successfully joined the family.',
  'family_toast_02': 'The application has been submitted, please wait for approval.',
  'family_toast_08': 'Create Family',
  'family_enter': 'Family',
  'specialoffer_9': 'Special Offer',
  'specialoffer_10': '{%s} Coins',
  'rewardboost_24': 'No available Special Offer.',
  'ramadan_daily_pool': 'Daily Pool',
  'ramadan_grand_pool': 'Grand Pool',
  'ramadan_sharing_countdown': 'Sharing Countdown:',
  'ramadan_today_coin_get': 'Yesterday\'s prize pool been shared! You have received:',
  'ramadan_top3_reward': 'Daily TOP3 can get corresponding rewards.',
  'ramadan_up_need': 'UP NEED{N}{Pointicon}',
  'ramadan_sign_days': 'Sign-In for {N} days',
  'spring.cp.cruise.my.count': 'My Count',
  'Noble_Change_5_METR': 'Example: If you are currently a Viscount (499950 coins/month), with 13 days left, and you purchase a Count (999950 coins/month) today, then after payment, the Count\'s validity period will be 13 * (499950/999950) + 30 = 6.5 rounded down + 30 = 36 days.',
  'Noble_Change_5_TR': 'Example: If you are currently a Viscount (499950 coins/month), with 13 days left, and you purchase a Count (999950 coins/month) today, then after payment, the Count\'s validity period will be 13 * (499950/999950) + 30 = 6.5 rounded down + 30 = 36 days.',
  'Noble_Change_5_ME': 'Example: If you are currently a Viscount (999900 coins/month), with 13 days left, and you purchase a Count (1999900 coins/month) today, then after payment, the Count\'s validity period will be 13 * (999900/1999900) + 30 = 6.5 rounded down + 30 = 36 days.',
  'lasser.bairam.rank.no.self': 'Sorry, you are not currently on the leaderboard.',
  'lucky.packet.7_TR': '3.The per capita amount (amount of coins/number of people) needs to be more than or equal to 5 coins.',
  'lucky.packet.7_ME': '3.The per capita amount (amount of coins/number of people) needs to be more than or equal to 10 coins.',
  'lucky.packet.8_TR': '4.When the amount of the packet is more than 50000 coins and the number of people is more than 10 will trigger world notification, and a special icon will be displayed in the room list.',
  'lucky.packet.8_ME': '4.When the amount of the packet is more than 100000 coins and the number of people is more than 10 will trigger world notification, and a special icon will be displayed in the room list.',
  'detail_recharge': 'Recharge',
  'detail_chat': 'Chat',
  'detail_gift': 'Gift',
  'detail_game': 'Game',
  'detail_rewards': 'Rewards',
  'detail_other': 'Other',
  'detail_return': 'Return',
  'cp_ranking_total': 'Total',
  'cp_ranking_longest': 'Longest CP',
  'cp_ranking_title': 'CP Ranking',
  'anchor_center_income': 'Income',
  'anchor_center_balance': 'Balance',
  'anchor_center_withdraw': 'Withdraw',
  'anchor_center_exchange': 'Exchange',
  'anchor_center_anchor_benefits': 'Anchor Benefits',
  'anchor_center_the_higher_your_level_the_more_often_you_are_sho': 'The higher your level, the more often you are shown to others and the more messages you receive.',
  'anchor_center_active_time_value': 'Active Time: {0}',
  'anchor_center_1_point_10_mins_active': '1 point / {0} mins active',
  'anchor_center_voice_room_active_time_value': 'On Mic Time : {0}',
  'anchor_center_until_level': '1 point / {0} mins',
  'anchor_center_number_of_replied_users_value': 'Earn diamonds by replying to messages: {0}',
  'anchor_center_1_point_reply_5_users': '1 point / {0} users',
  'anchor_center_exchange_2': 'Exchange',
  'anchor_center_1_point_per_1000_coins': '1 point / per {0} coins',
  'anchor_center_anchor_level_guide': 'Anchor Level Guide',
  'anchor_center_1_anchor_levels_are_calculated_every_two_weeks': '1.Anchor levels are calculated every two weeks.\\n2.Rewards will be issued immediately once you reach the required level.\\n3.Silver: {%s1} points\\nGold: {%s2} points\\nDiamond: {%s3} points.',
  'anchor_center_1_anchor_levels_are_calculated_every_two_weeks_2': '1.Anchor levels are calculated every {%s4} week.\\n2.Rewards will be issued immediately once you reach the required level.\\n3.Silver: {%s1} points\\nGold: {%s2} points\\nDiamond: {%s3} points.\\n4.Online time and active time in voice rooms are calculated separately.',
  'anchor_center_level1': 'Silver',
  'anchor_center_level2': 'Gold',
  'anchor_center_level3': 'Diamond',
  'anchor_center_level': 'Anchor Level',
};

export default EN;
